webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuexRouterSync = __webpack_require__(241);
	
	var _store = __webpack_require__(46);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueRouter = __webpack_require__(240);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(230);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	var router = new _vueRouter2.default();
	(0, _vuexRouterSync.sync)(_store2.default, router);
	router.map({
	  '/': {
	    component: _App2.default
	  }
	});
	router.start(_App2.default, 'html');

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(108);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(110);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(17);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(47);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.isFunction = isFunction;
	exports.isString = isString;
	exports.isNumber = isNumber;
	exports.isArray = isArray;
	exports.ensureArray = ensureArray;
	exports.isBoolean = isBoolean;
	exports.isDate = isDate;
	exports.isObject = isObject;
	exports.isHash = isHash;
	exports.toString = toString;
	exports.escapeRegExp = escapeRegExp;
	exports.includes = includes;
	exports.contains = contains;
	exports.uniq = uniq;
	exports.union = union;
	exports.keys = keys;
	exports.capitalize = capitalize;
	exports.stringToPathArray = stringToPathArray;
	exports.has = has;
	exports.forEach = forEach;
	exports.without = without;
	exports.map = map;
	exports.mapValues = mapValues;
	exports.filter = filter;
	exports.find = find;
	exports.omitBy = omitBy;
	exports.pickBy = pickBy;
	exports.get = get;
	exports.set = set;
	exports.vueSet = vueSet;
	exports.merge = merge;
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isFunction(obj) {
	  return typeof obj === 'function';
	}
	
	function isString(obj) {
	  return typeof obj === 'string';
	}
	
	function isNumber(obj) {
	  return typeof obj === 'number';
	}
	
	function isArray(obj) {
	  return Array.isArray(obj);
	}
	
	function ensureArray(obj) {
	  return !obj ? [] : isArray(obj) ? obj : [obj];
	}
	
	function isBoolean(obj) {
	  return typeof obj === 'boolean';
	}
	
	function isDate(obj) {
	  return obj instanceof Date;
	}
	
	function isObject(obj) {
	  return (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj !== null;
	}
	
	function isHash(obj) {
	  return isObject(obj) && !isArray(obj) && !isDate(obj) && obj !== null;
	}
	function toString(obj) {
	  try {
	    if (isHash(obj) || isArray(obj)) return (0, _stringify2.default)(obj);else if (has(obj, 'toString')) return obj.toString();else return String(obj);
	  } catch (err) {}
	  return '';
	}
	
	function escapeRegExp(str) {
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	  var reHasRegExpChar = RegExp(reRegExpChar.source);
	  str = toString(str);
	  return str && reHasRegExpChar.test(str) ? str.replace(reRegExpChar, '\\$&') : str;
	}
	
	function includes(obj, key) {
	  try {
	    return isArray(obj) && obj.indexOf(key) !== -1;
	  } catch (err) {
	    return false;
	  }
	}
	
	function contains(list, obj) {
	  var found = false;
	  forEach(list, function (item) {
	    if (item === obj) {
	      found = true;
	      return false;
	    }
	  });
	  return found;
	}
	
	function uniq(list) {
	  var newList = [];
	  forEach(list, function (item) {
	    if (!contains(newList, item)) newList.push(item);
	  });
	  return newList;
	}
	
	function union() {
	  var args = Array.prototype.slice.call(arguments);
	  var newList = [];
	  forEach(args, function (list) {
	    newList = newList.concat(list);
	  });
	  return uniq(newList);
	}
	
	function keys(obj) {
	  try {
	    return (0, _keys2.default)(obj);
	  } catch (err) {
	    return [];
	  }
	}
	
	function capitalize(str) {
	  if (isString(str) && str.length > 0) {
	    var first = str[0];
	    var rest = str.length > 1 ? str.substring(1) : '';
	    str = [first.toUpperCase(), rest.toLowerCase()].join('');
	  }
	  return str;
	}
	
	function stringToPathArray(pathString) {
	  var pathRx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(\.|\[\])(?:\4|$))/g;
	  var pathArray = [];
	
	  if (isString(pathString)) {
	    pathString.replace(pathRx, function (match, number, quote, string) {
	      pathArray.push(quote ? string : number !== undefined ? Number(number) : match);
	      return pathArray[pathArray.length - 1];
	    });
	  }
	  return pathArray;
	}
	
	function has(obj, path) {
	  var value = obj;
	  var fields = isArray(path) ? path : stringToPathArray(path);
	  if (fields.length === 0) return false;
	  try {
	    for (var f in fields) {
	      if (!value[fields[f]]) return false;else value = value[fields[f]];
	    }
	  } catch (err) {
	    return false;
	  }
	  return true;
	}
	
	function forEach(obj, fn) {
	  try {
	    if (Array.isArray(obj)) {
	      var idx = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(obj), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var val = _step.value;
	
	          if (fn(val, idx) === false) break;
	          idx++;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    } else {
	      for (var key in obj) {
	        if (fn(obj[key], key) === false) break;
	      }
	    }
	  } catch (err) {
	    return;
	  }
	}
	
	function without() {
	  var output = [];
	  var args = Array.prototype.slice.call(arguments);
	  if (args.length === 0) return output;else if (args.length === 1) return args[0];
	  var search = args.slice(1);
	  forEach(args[0], function (val) {
	    if (!includes(search, val)) output.push(val);
	  });
	  return output;
	}
	
	function map(obj, fn) {
	  var output = [];
	  try {
	    for (var key in obj) {
	      output.push(fn(obj[key], key));
	    }
	  } catch (err) {
	    return [];
	  }
	  return output;
	}
	
	function mapValues(obj, fn) {
	  var newObj = {};
	  try {
	    forEach(obj, function (v, k) {
	      newObj[k] = fn(v);
	    });
	  } catch (err) {
	    return obj;
	  }
	  return newObj;
	}
	
	function filter(obj, fn) {
	  var newObj = [];
	  if (!isArray(obj)) return newObj;
	  forEach(obj, function (v, k) {
	    if (fn(v, k)) newObj.push(v);
	  });
	  return newObj;
	}
	
	function find(obj, fn, def) {
	  var found = def || null;
	  forEach(obj, function (v, k) {
	    if (fn(v, k)) {
	      found = v;
	      return false;
	    }
	  });
	  return found;
	}
	
	function omitBy(obj, fn) {
	  var newObj = {};
	  if (!isHash(obj)) return newObj;
	  forEach(obj, function (v, k) {
	    if (!fn(v, k)) newObj[k] = v;
	  });
	  return newObj;
	}
	
	function pickBy(obj, fn) {
	  var newObj = {};
	  if (!isHash(obj)) return newObj;
	  forEach(obj, function (v, k) {
	    if (fn(v, k)) newObj[k] = v;
	  });
	  return newObj;
	}
	
	function get(obj, path, defaultValue) {
	  var value = obj;
	  var fields = isArray(path) ? path : stringToPathArray(path);
	  if (fields.length === 0) return defaultValue;
	
	  try {
	    for (var f in fields) {
	      if (!value[fields[f]]) return defaultValue;else value = value[fields[f]];
	    }
	  } catch (err) {
	    return defaultValue;
	  }
	  return value;
	}
	
	function set(obj, path, val) {
	  var value = obj;
	  var fields = isArray(path) ? path : stringToPathArray(path);
	  for (var f in fields) {
	    var idx = Number(f);
	    var p = fields[idx];
	    if (idx === fields.length - 1) value[p] = val;else if (!value[p]) value[p] = isNumber(p) ? [] : {};
	    value = value[p];
	  }
	}
	
	function vueSet(obj, path, val) {
	  var value = obj;
	  var fields = isArray(path) ? path : stringToPathArray(path);
	  for (var f in fields) {
	    var idx = Number(f);
	    var p = fields[idx];
	    if (idx === fields.length - 1) _vue2.default.set(value, p, val);else if (!value[p]) _vue2.default.set(value, p, isNumber(p) ? [] : {});
	    value = value[p];
	  }
	}
	
	function merge() {
	  var args = Array.prototype.slice.call(arguments);
	  if (args.length === 0) return {};else if (args.length === 1) return args[0];else if (!isHash(args[0])) return {};
	  var targetObject = args[0];
	  var sources = args.slice(1);
	
	  var _merge = function _merge(target, source) {
	    for (var k in source) {
	      if (!target[k] && isHash(source[k])) {
	        target[k] = _merge({}, source[k]);
	      } else if (target[k] && isHash(target[k]) && isHash(source[k])) {
	        target[k] = merge(target[k], source[k]);
	      } else {
	        if (isArray(source[k])) {
	          target[k] = [];
	          for (var x in source[k]) {
	            if (isHash(source[k][x])) {
	              target[k].push(_merge({}, source[k][x]));
	            } else if (isArray(source[k][x])) {
	              target[k].push(_merge([], source[k][x]));
	            } else {
	              target[k].push(source[k][x]);
	            }
	          }
	        } else if (isDate(source[k])) {
	          target[k] = new Date(source[k]);
	        } else {
	          target[k] = source[k];
	        }
	      }
	    }
	    return target;
	  };
	
	  for (var k in sources) {
	    if (isHash(sources[k])) _merge(targetObject, sources[k]);
	  }
	  return targetObject;
	}

/***/ },
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var changeTheme = exports.changeTheme = function changeTheme(_ref, theme) {
	  var dispatch = _ref.dispatch;
	
	  dispatch('CHANGE_THEME', theme);
	};
	var customTheme = exports.customTheme = function customTheme(_ref2, theme) {
	  var dispatch = _ref2.dispatch;
	
	  dispatch('CUSTOM_THEME', theme);
	};
	var changeInvertedLogo = exports.changeInvertedLogo = function changeInvertedLogo(_ref3, inverted) {
	  var dispatch = _ref3.dispatch;
	
	  dispatch('CHANGE_INVERTED_LOGO', inverted);
	};
	var activateMainTab = exports.activateMainTab = function activateMainTab(_ref4, tab) {
	  var dispatch = _ref4.dispatch;
	
	  dispatch('ACTIVATE_MAIN_TAB', tab);
	};
	var setCollapsed = exports.setCollapsed = function setCollapsed(_ref5, tab, collapsed) {
	  var dispatch = _ref5.dispatch;
	
	  dispatch('SET_COLLAPSED', tab, collapsed);
	};

/***/ },
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hello = exports.ThemeSelector = exports.FTabs = exports.FSelect = exports.Formation = exports.FModal = undefined;
	
	var _FModal = __webpack_require__(234);
	
	var _FModal2 = _interopRequireDefault(_FModal);
	
	var _Formation = __webpack_require__(236);
	
	var _Formation2 = _interopRequireDefault(_Formation);
	
	var _FSelect = __webpack_require__(68);
	
	var _FSelect2 = _interopRequireDefault(_FSelect);
	
	var _FTabs = __webpack_require__(235);
	
	var _FTabs2 = _interopRequireDefault(_FTabs);
	
	var _ThemeSelector = __webpack_require__(70);
	
	var _ThemeSelector2 = _interopRequireDefault(_ThemeSelector);
	
	var _Hello = __webpack_require__(69);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FModal = _FModal2.default;
	exports.Formation = _Formation2.default;
	exports.FSelect = _FSelect2.default;
	exports.FTabs = _FTabs2.default;
	exports.ThemeSelector = _ThemeSelector2.default;
	exports.Hello = _Hello2.default;
	exports.default = {
	  FModal: _FModal2.default,
	  Formation: _Formation2.default,
	  FSelect: _FSelect2.default,
	  FTabs: _FTabs2.default,
	  ThemeSelector: _ThemeSelector2.default,
	  Hello: _Hello2.default
	};

/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'Simple Form',
	  exampleType: 'formation',
	  description: 'A simple reactive form that can be cleared and displays a modal when submitted. First Name is required.',
	  headerClass: 'bg-primary',
	  formConfig: {
	    liveValidation: true,
	    rows: [{
	      columns: [{
	        type: 'text',
	        label: 'First Name',
	        model: 'firstName',
	        required: true
	      }, {
	        type: 'text',
	        label: 'Last Name',
	        model: 'lastName'
	      }]
	    }, {
	      columns: [{
	        type: 'buttons',
	        buttons: [{
	          text: 'Clear',
	          class: 'btn-default',
	          iconClass: 'glyphicon glyphicon-remove',
	          onClick: function onClick(event, vm) {
	            vm.setData(['firstName', 'lastName'], '');
	          }
	        }, {
	          text: 'Submit',
	          class: 'btn-primary',
	          iconClass: 'glyphicon glyphicon-ok',
	          onClick: function onClick(event, vm) {
	            if (!vm.validate()) return;
	            vm.$root.$broadcast('modal.show', {
	              title: 'Hello!',
	              body: 'Welcome ' + vm.data.firstName + ' ' + vm.data.lastName,
	              footerButtons: [{
	                content: 'Close',
	                class: 'btn btn-default',
	                onClick: function onClick(event, modal) {
	                  modal.hide();
	                }
	              }]
	            }, 'dialog');
	          }
	        }]
	      }]
	    }]
	  },
	  formData: {
	    firstName: '',
	    lastName: ''
	  },
	  formHtml: '<formation :data.sync="data" :config="config">'
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  methods: {
	    typeLinks: function typeLinks(obj) {
	      var _this = this;
	
	      if (_.isString(obj)) obj = obj.split('|');else if (!_.isArray(obj)) obj = [obj];
	      var links = _.map(obj, function (o) {
	        if (_.isString(o)) return '<a href="' + _.get(_this.native, o.trim(), '') + '"><code>' + o.trim() + '</code></a>';else return '<a href="' + (o.link || _.get(_this.native, o.name, '')) + '"><code>' + o.name + '</code></a>';
	      });
	      return links.join(' | ');
	    }
	  },
	  data: function data() {
	    return {
	      native: {
	        Boolean: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean',
	        Number: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number',
	        Object: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object',
	        Array: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array',
	        String: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String',
	        Date: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date',
	        Function: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function'
	      }
	    };
	  }
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Helper = exports.hasClass = exports.toggleClass = exports.removeClass = exports.addClass = undefined;
	
	var _classCallCheck2 = __webpack_require__(113);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(114);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _typeof2 = __webpack_require__(47);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.findCss = findCss;
	exports.getStyle = getStyle;
	exports.pxToInt = pxToInt;
	exports.removeEvent = removeEvent;
	exports.onEvent = onEvent;
	exports.onceEvent = onceEvent;
	exports.onReady = onReady;
	exports.mapNodes = mapNodes;
	
	exports.default = function (selector) {
	  return new Helper(selector);
	};
	
	var _utils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function findCss(selectorText, props) {
	  var css = {};
	  props = Array.isArray(props) ? props : [props];
	  (0, _utils.forEach)(document.styleSheets, function (sheet) {
	    var rules = sheet.rules || sheet.cssRules;
	    (0, _utils.forEach)(rules, function (rule) {
	      if (rule.selectorText.indexOf(selectorText) !== -1) {
	        console.log(rule.selectorText);
	        (0, _utils.forEach)(props, function (name) {
	          var currentVal = (0, _utils.get)(rule, 'style["' + name + '"]');
	          if (currentVal) css[name] = currentVal;
	        });
	      }
	    });
	  });
	  return css;
	}
	
	function getStyle(element, props) {
	  var obj = {};
	  var cs = window.getComputedStyle(element, null);
	  (0, _utils.forEach)((0, _utils.ensureArray)(props), function (prop) {
	    try {
	      obj[prop] = cs.getPropertyValue(prop);
	    } catch (err) {}
	  });
	  return obj;
	}
	
	function pxToInt(px) {
	  var i = Number(px.replace(/px$/i, ''));
	  return !isNaN(i) ? i : 0;
	}
	
	function removeEvent(element, event, fn) {
	  element.removeEventListener(event, fn);
	}
	
	function onEvent(element, event, callback, useCapture) {
	  element.addEventListener(event, callback, useCapture);
	  return function () {
	    removeEvent(element, event, callback);
	  };
	}
	
	function onceEvent(element, event, callback, useCapture) {
	  var fn = function fn(event) {
	    callback(event);
	    removeEvent(element, event, this);
	  };
	  onEvent(element, event, fn, useCapture);
	  return function () {
	    removeEvent(element, event, fn);
	  };
	}
	
	function onReady(element, callback) {
	  return onceEvent(element, 'DOMContentLoaded', callback);
	}
	
	function _addClass(element, className) {
	  var classList = Array.isArray(className) ? className : className.split(/\s+/);
	  (0, _utils.forEach)(classList, function (c) {
	    element.classList.add(c);
	  });
	}
	
	exports.addClass = _addClass;
	function _removeClass(element, className) {
	  var classList = Array.isArray(className) ? className : className.split(/\s+/);
	  (0, _utils.forEach)(classList, function (c) {
	    element.classList.remove(c);
	  });
	}
	
	exports.removeClass = _removeClass;
	function _toggleClass(element, className, force) {
	  return element.classList.toggle(className, force);
	}
	
	exports.toggleClass = _toggleClass;
	function _hasClass(element, className) {
	  return element.classList.contains(className);
	}
	
	exports.hasClass = _hasClass;
	function mapNodes(element, selector) {
	  return (0, _utils.without)((0, _utils.map)(element.querySelectorAll(selector), function (v) {
	    return (typeof v === 'undefined' ? 'undefined' : (0, _typeof3.default)(v)) === 'object' ? v : undefined;
	  }), undefined);
	}
	
	var Helper = exports.Helper = function () {
	  function Helper(selector) {
	    (0, _classCallCheck3.default)(this, Helper);
	
	    this.el = [];
	    if (selector instanceof Helper) this.el[0] = selector.el;else if (typeof selector === 'string') this.el = mapNodes(document, selector);else if (Array.isArray(selector)) this.el = selector;else this.el[0] = selector;
	  }
	
	  (0, _createClass3.default)(Helper, [{
	    key: 'ready',
	    value: function ready(callback, returnRemove) {
	      var removeFn = onReady(this.el[0], callback);
	      return returnRemove ? removeFn : this;
	    }
	  }, {
	    key: 'on',
	    value: function on(event, callback, useCapture, returnRemove) {
	      var removeFn = onEvent(this.el[0], event, callback, useCapture);
	      return returnRemove ? removeFn : this;
	    }
	  }, {
	    key: 'once',
	    value: function once(event, callback, useCapture, returnRemove) {
	      var removeFn = onceEvent(this.el[0], callback);
	      return returnRemove ? removeFn : this;
	    }
	  }, {
	    key: 'click',
	    value: function click(callback, useCapture, returnRemove) {
	      var removeFn = onEvent(this.el[0], 'click', callback, useCapture);
	      return returnRemove ? removeFn : this;
	    }
	  }, {
	    key: 'addClass',
	    value: function addClass(clazz) {
	      return this.each(function (el) {
	        _addClass(el, clazz);
	      });
	    }
	  }, {
	    key: 'removeClass',
	    value: function removeClass(clazz) {
	      return this.each(function (el) {
	        _removeClass(el, clazz);
	      });
	    }
	  }, {
	    key: 'toggleClass',
	    value: function toggleClass(clazz, force) {
	      return this.each(function (el) {
	        _toggleClass(el, clazz, force);
	      });
	    }
	  }, {
	    key: 'hasClass',
	    value: function hasClass(clazz) {
	      return _hasClass(this.el[0], clazz);
	    }
	  }, {
	    key: 'each',
	    value: function each(callback) {
	      (0, _utils.forEach)(this.el, function (v, k) {
	        callback(v, k);
	      });
	      return this;
	    }
	  }, {
	    key: 'find',
	    value: function find(selector) {
	      return new Helper(mapNodes(this.el[0], selector));
	    }
	  }]);
	  return Helper;
	}();

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stringify = stringify;
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var endRx = /,\n?$/;
	
	function getType(obj) {
	  return Object.prototype.toString.call(obj).replace('[object ', '').replace(']', '');
	}
	
	function toStr(obj, replacer, space, depth) {
	  var type = getType(obj);
	  var output = '';
	  var ret = replacer !== undefined && space ? '\n' : '';
	
	  depth = depth || 0;
	  space = space || '';
	
	  var spaces = space.repeat(depth);
	
	  if (type === 'Null') {
	    output += 'null,' + ret;
	  } else if (type === 'Undefined') {
	    output += 'undefined,' + ret;
	  } else if (type === 'Array') {
	    output += '[' + ret;
	    _.forEach(obj, function (value, idx) {
	      if (typeof replacer === 'function') {
	        value = replacer(idx, value);
	      }
	      output += [spaces, space, toStr(value, replacer, space, depth + 1)].join('');
	    });
	    output = output.replace(endRx, ret);
	    output += spaces + '],' + ret;
	  } else if (type === 'Object') {
	    output += '{' + ret;
	    _.forEach(obj, function (value, key) {
	      if (typeof replacer === 'function') {
	        value = replacer(key, value);
	      }
	      output += [spaces, space, '"', key, '":', toStr(value, replacer, space, depth + 1)].join('');
	    });
	    output = output.replace(endRx, ret);
	    output += spaces + '},' + ret;
	  } else if (type === 'Function') {
	    var o = obj.toString();
	    if (replacer === undefined || !space) {
	      o = o.replace(/\s+/g, ' ');
	    } else {
	      var fnIndent = o.match('\n[ \t]+');
	
	      if (fnIndent) {
	        var fnRx = new RegExp(fnIndent[0].replace(/\n/g, '\\n').replace(/\t/g, '\\t'), 'g');
	        o = o.replace(fnRx, '\n' + spaces + space).replace(/\s+}$/, '\n' + spaces + '}').replace(/\t/g, space);
	      }
	    }
	    output += o + ',' + ret;
	  } else if (type === 'Boolean') {
	    output += String(obj) + ',' + ret;
	  } else if (type === 'Number') {
	    output += obj + ',' + ret;
	  } else {
	    output += ['"', String(obj).replace(/"/g, '\\"'), '",', ret].join('');
	  }
	
	  return output;
	}
	
	function stringify(obj, replacer, space) {
	  return toStr(obj, replacer, space).replace(endRx, '');
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(242);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _theme = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = (0, _assign2.default)({}, _theme.state);
	var mutations = (0, _assign2.default)({}, _theme.mutations);
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations
	});

/***/ },
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(160)
	__vue_script__ = __webpack_require__(100)
	__vue_template__ = __webpack_require__(222)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(164)
	__vue_script__ = __webpack_require__(104)
	__vue_template__ = __webpack_require__(229)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(106)
	__vue_template__ = __webpack_require__(227)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FModal',
	  exampleId: 'ModalEx1',
	  params: [{
	    name: 'show',
	    type: 'Boolean',
	    twoWay: true,
	    required: false,
	    default: '<code>false</code>',
	    description: 'Opens or closes modal'
	  }, {
	    name: 'config',
	    type: 'Object',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Allows modal content to be set via object instead of slot'
	  }, {
	    name: 'modal-id',
	    type: 'String',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'When specified the <code>modal.show</code> listener will only show the modal if the modalId is passed as an argument'
	  }, {
	    name: 'backdrop',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: '<code>true</code>',
	    description: 'Show a backdrop with the modal'
	  }, {
	    name: 'backdrop-opacity',
	    type: 'Number',
	    twoWay: false,
	    required: false,
	    default: '<code>0.5</code>',
	    description: 'Opacity of the backdrop'
	  }, {
	    name: 'exclusive',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: '<code>true</code>',
	    description: 'When true, sends a <code>modal.hide</code> event to all other modals before opening'
	  }, {
	    name: 'z-index',
	    type: 'Number',
	    twoWay: false,
	    required: false,
	    default: '<code>2000000000</code>',
	    description: 'zIndex of the modal'
	  }, {
	    name: 'animation',
	    type: 'String',
	    twoWay: false,
	    required: false,
	    default: '<code>fade-modal</code>',
	    description: 'Transition to use when opening/closing the modal'
	  }],
	  events: [{
	    type: 'modal.opening / show.bs.modal',
	    description: 'These events fire before the modal is opened'
	  }, {
	    type: 'modal.open / shown.bs.modal',
	    description: 'These events fire after the modal is opened'
	  }, {
	    type: 'modal.closing / hide.bs.modal',
	    description: 'These events fire before the modal is closed'
	  }, {
	    type: 'modal.close / hidden.bs.modal',
	    description: 'These events fire after the modal is closed'
	  }],
	  listeners: [{
	    type: 'modal.show (config, id)',
	    description: 'When triggered, opens the modal',
	    params: [{
	      name: 'config',
	      type: 'Object',
	      description: 'Configuration object to use'
	    }, {
	      name: 'id',
	      type: 'String',
	      description: 'ID of the specific modal to open. Used with the <code>modalId</code> parameter'
	    }]
	  }, {
	    type: 'modal.hide',
	    description: 'When triggered, hides the modal'
	  }]
	};

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'Formation',
	  exampleId: 'FormationEx1',
	  params: [{
	    name: 'config',
	    type: 'Object&lt;FormationConfig&gt;',
	    twoWay: false,
	    required: true,
	    default: null,
	    description: 'Formation configuration object'
	  }, {
	    name: 'data',
	    type: 'Object',
	    twoWay: true,
	    required: true,
	    default: null,
	    description: 'Data object to bind'
	  }, {
	    name: 'width',
	    type: 'String | Number',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Width of component (e.g "100%" or "500px"). Numbers will be evaluated as pixels'
	  }],
	  events: [{
	    type: 'formation.error ( info )',
	    description: 'This event fires immediately when an error encountered by either the formation component or any child components',
	    params: [{
	      name: 'info',
	      type: 'Object',
	      description: 'Contains details on the error including which component emitted the error'
	    }]
	  }]
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColButtonConfig',
	  description: 'Adds a button with access to the form data',
	  extends: 'FormationColStyledConfig',
	  structure: [{
	    path: 'onClick',
	    type: 'Function (event, vm)',
	    description: 'Called on button click events. Passes the event object as well as a reference to the ' + 'formation component instance. Data can be accessed via <code>vm.data</code>'
	  }, {
	    path: 'iconClass',
	    type: 'String | Array | Object',
	    description: 'Set a webfont icon on the button'
	  }, {
	    path: 'text',
	    type: 'String',
	    description: 'Button text'
	  }]
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColButtonsConfig',
	  description: 'Adds a button group',
	  extends: 'FormationColStyledConfig',
	  structure: [{
	    path: 'buttons',
	    type: {
	      name: 'Array&lt;FormationColButtonConfig&gt;',
	      link: '#FormationColButtonConfig'
	    },
	    required: true,
	    description: 'List of buttons'
	  }, {
	    path: 'group',
	    type: 'Boolean',
	    description: 'When <code>true</code> show as a button-group'
	  }]
	};

/***/ },
/* 75 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColCheckboxConfig',
	  description: 'Adds a checkbox',
	  extends: 'FormationColStyledConfig',
	  structure: []
	};

/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColConfig',
	  description: 'Defines settings for a Formation column. FormationColConfigs have standard configuration options that ' + 'can be extended with options for specific column types. See component documentation. All component options should' + 'be provided using camelCase',
	  structure: [{
	    path: 'type',
	    type: {
	      name: 'FormationColTypeEnum',
	      link: '#FormationColTypeEnum'
	    },
	    required: true,
	    description: 'A supported column type'
	  }, {
	    path: 'bind',
	    type: 'FormationColBind',
	    description: 'A collection of element binding actions'
	  }]
	};

/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColHtmlConfig',
	  description: 'Allows custom HTML',
	  extends: 'FormationColConfig',
	  structure: [{
	    path: 'value',
	    type: 'String',
	    description: 'Custom HTML'
	  }]
	};

/***/ },
/* 78 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColStyledConfig',
	  description: 'Applies custom CSS styling',
	  extends: 'FormationColConfig',
	  structure: [{
	    path: 'class',
	    type: 'String | Array | Object',
	    description: 'CSS class to set on the column'
	  }, {
	    path: 'style',
	    type: 'String | Array | Object',
	    description: 'Style attributes to set on the column'
	  }]
	};

/***/ },
/* 79 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColTextConfig',
	  description: 'Configuration for a text input. Includes password, email, search, etc.',
	  extends: 'FormationColStyledConfig',
	  structure: [{
	    path: 'label',
	    type: 'String',
	    description: 'Form label. Can contain HTML'
	  }, {
	    path: 'model',
	    type: 'String',
	    description: 'Data path to bind to'
	  }, {
	    path: 'validate',
	    type: 'Function (data)',
	    description: 'Validation function where <code>data</code> is the current form component value'
	  }, {
	    path: 'required',
	    type: 'Boolean',
	    default: '<code>false</code>',
	    description: 'When <code>true</code> the data value cannot be undefined or an empty array'
	  }]
	};

/***/ },
/* 80 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationColTypeEnum',
	  description: 'Supported column types',
	  enums: [{
	    value: 'text',
	    description: 'text type. Implemented by <a href="#FormationColTextConfig"><code>FormationColTextConfig</code></a>'
	  }, {
	    value: 'email',
	    description: 'email type. Implemented by <a href="#FormationColTextConfig"><code>FormationColTextConfig</code></a>'
	  }, {
	    value: 'password',
	    description: 'password type. Implemented by <a href="#FormationColTextConfig"><code>FormationColTextConfig</code></a>'
	  }, {
	    value: 'number',
	    description: 'number type. Implemented by <a href="#FormationColTextConfig"><code>FormationColTextConfig</code></a>'
	  }, {
	    value: 'search',
	    description: 'search type. Implemented by <a href="#FormationColTextConfig"><code>FormationColTextConfig</code></a>'
	  }, {
	    value: 'url',
	    description: 'url type. Implemented by <a href="#FormationColTextConfig"><code>FormationColTextConfig</code></a>'
	  }, {
	    value: 'tel',
	    description: 'tel type. Implemented by <a href="#FormationColTextConfig"><code>FormationColTextConfig</code></a>'
	  }, {
	    value: 'html',
	    description: 'Allows custom HTML. Implemented by <a href="#FormationColHtmlConfig"><code>FormationColHtmlConfig</code></a>'
	  }, {
	    value: 'button',
	    description: 'button type. Implemented by <a href="#FormationColButtonConfig"><code>FormationColButtonConfig</code></a>'
	  }, {
	    value: 'buttons',
	    description: 'button group type. Implemented by <a href="#FormationColButtonsConfig"><code>FormationColButtonsConfig</code></a>'
	  }, {
	    value: 'checkbox',
	    description: 'checkbox type. Implemented by <a href="#FormationColCheckboxConfig"><code>FormationColCheckboxConfig</code></a>'
	  }, {
	    value: 'radio',
	    description: 'radio type. Implemented by <i>documentation in progress...</i>',
	    undocumented: true
	  }, {
	    value: 'select',
	    description: 'select type. Implemented by <i>documentation in progress...</i>',
	    undocumented: true
	  }, {
	    value: 'slot',
	    description: 'slot type. Implemented by <i>documentation in progress...</i>',
	    undocumented: true
	  }, {
	    value: 'fselect',
	    description: 'FSelect type. Implemented by <i>documentation in progress...</i>',
	    undocumented: true
	  }]
	};

/***/ },
/* 81 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationConfig',
	  description: 'Used by a formation component to provide the layout and options for a form. The object is bound to ' + 'the component so any modifications after the initial render/compile will be re-rendered/compiled automatically. ' + 'This allows your forms to be more dynamic and even reconfigure themselves based on the current supplied user input',
	  example: {
	    liveValidation: false,
	    rows: [{
	      columns: [{
	        type: 'text',
	        label: 'First Name',
	        model: 'firstName'
	      }]
	    }]
	  },
	  structure: [{
	    path: 'liveValidation',
	    type: 'Boolean',
	    default: '<code>false</code>',
	    description: 'Validates all forms on first and subsequent user input'
	  }, {
	    path: 'format',
	    type: 'String',
	    description: 'Layout type. Valid values are <code>"inline"</code> and <code>"horizontal"</code>'
	  }, {
	    path: 'framework',
	    type: 'String',
	    default: '<code>"bootstrap"</code>',
	    description: 'CSS framework to use. Currently Bootstrap is the only framework supported'
	  }, {
	    path: 'transition',
	    type: 'String',
	    description: 'Vue transition'
	  }, {
	    path: 'transitionEnter',
	    type: 'String',
	    description: 'Vue enter transition'
	  }, {
	    path: 'transitionLeave',
	    type: 'String',
	    description: 'Vue leave transition'
	  }, {
	    path: 'stagger',
	    type: 'Number',
	    description: 'Vue transition stagger'
	  }, {
	    path: 'enterStagger',
	    type: 'Number',
	    description: 'Vue transition enter stagger'
	  }, {
	    path: 'leaveStagger',
	    type: 'Number',
	    description: 'Vue transition leave stagger'
	  }, {
	    path: 'align',
	    type: 'String',
	    default: 'inherited',
	    description: 'Content alignment. Valid values are <code>"left"</code> and <code>"right"</code>'
	  }, {
	    path: 'rows',
	    type: {
	      name: 'Array&lt;FormationRowConfig&gt;',
	      link: '#FormationRowConfig'
	    },
	    required: true,
	    description: 'A list of "rows"'
	  }]
	};

/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FormationRowConfig',
	  description: 'Defines settings for a Formation row',
	  structure: [{
	    path: 'class',
	    type: 'String | Array | Object',
	    description: 'One or more CSS class to add to the row'
	  }, {
	    path: 'style',
	    type: 'String | Array | Object',
	    description: 'Style attributes to add to the row'
	  }, {
	    path: 'columns',
	    type: {
	      name: 'Array&lt;FormationColConfig&gt;',
	      link: '#FormationColConfig'
	    },
	    description: 'List of columns for the current row'
	  }]
	};

/***/ },
/* 83 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FSelect',
	  exampleId: 'SelectEx1',
	  params: [{
	    name: 'align',
	    type: 'String',
	    twoWay: false,
	    required: false,
	    default: '<code>"left"</code>',
	    description: 'Aligns the text'
	  }, {
	    name: 'allow-clear',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: '<code>true</code>',
	    description: 'When using multiple select, display a clear form <code>x</code>'
	  }, {
	    name: 'allow-multiple',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: '<code>false</code>',
	    description: 'Allow the same value to be selected more than once'
	  }, {
	    name: 'caret-class',
	    type: 'String | Array | Object',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Specify a custom caret class'
	  }, {
	    name: 'close-on-select',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: '<code>true</code>',
	    description: 'Close the select menu on each selection when using <code>multiple</code>'
	  }, {
	    name: 'disabled',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: '<code>false</code>',
	    description: 'Disables the form when truthy'
	  }, {
	    name: 'option-limit',
	    type: 'Number',
	    twoWay: false,
	    required: false,
	    default: '<code>5</code>',
	    description: 'Maximum number of select options to display'
	  }, {
	    name: 'multiple',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: '<code>false</code>',
	    description: 'Allow multiple selections'
	  }, {
	    name: 'on-change',
	    type: 'Function (type, value, vm)',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Function to call on change where type is <code>"add"</code>, <code>"remove"</code>, or <code>"clear"</code>'
	  }, {
	    name: 'on-changing',
	    type: 'Function (type, value, vm)',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'If specified, requsted changes (<code>"add"</code>, <code>"remove"</code>, or <code>"clear"</code>) will first run the provided function. If the function returns <code>false</code> the change will not proceed.'
	  }, {
	    name: 'options',
	    type: 'Array',
	    twoWay: false,
	    required: true,
	    default: null,
	    description: 'A list of option objects'
	  }, {
	    name: 'placeholder',
	    type: 'String',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Placeholder text when no options are selected'
	  }, {
	    name: 'remove-class',
	    type: 'String | Array | Object',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Class to apply to remove buttons'
	  }, {
	    name: 'remove-selected-options',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: 'false',
	    description: 'Removes options from the option list when selected'
	  }, {
	    name: 'searchable',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: 'true',
	    description: 'Show an option search form'
	  }, {
	    name: 'select-id',
	    type: 'String',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'An identifier string for the select menu which when set is required as a parameter when making changes via events'
	  }, {
	    name: 'store-object',
	    type: 'Boolean',
	    twoWay: false,
	    required: false,
	    default: 'false',
	    description: 'When <code>true</code> the option object will be stored in the value instead of just the value'
	  }, {
	    name: 'tag-class',
	    type: 'String | Array | Object',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Class to apply to tags'
	  }, {
	    name: 'text-key',
	    type: 'String',
	    twoWay: false,
	    required: false,
	    default: 'text',
	    description: 'Key path in an object to the text attribute'
	  }, {
	    name: 'value',
	    type: 'String | Array',
	    twoWay: true,
	    required: true,
	    default: null,
	    description: 'Selected value(s). Will always be converted into an <code>Array</code>'
	  }, {
	    name: 'value-key',
	    type: 'String',
	    twoWay: false,
	    required: false,
	    default: 'value',
	    description: 'Key path in an object to the value attribute'
	  }, {
	    name: 'width',
	    type: 'String | Number',
	    twoWay: false,
	    required: false,
	    default: null,
	    description: 'Width of the select menu'
	  }],
	  events: [{
	    type: 'fselect.changing (type, value, vm, id)',
	    description: 'Fired before any changes are made',
	    params: [{
	      name: 'type',
	      type: 'String',
	      description: 'The type of change being made (<code>"add"</code>, <code>"remove"</code>, or <code>"clear"</code>)'
	    }, {
	      name: 'value',
	      type: '*',
	      description: 'The value used in the change'
	    }, {
	      name: 'vm',
	      type: 'VueComponent',
	      description: 'The fselect vue instance'
	    }, {
	      name: 'id',
	      type: 'String',
	      description: 'The fselect id if set'
	    }]
	  }, {
	    type: 'fselect.changed',
	    description: 'Fired after a change is made'
	  }, {
	    type: 'fselect.adding',
	    description: 'Fired before a value is added'
	  }, {
	    type: 'fselect.added',
	    description: 'Fired after a value is added'
	  }, {
	    type: 'fselect.removing',
	    description: 'Fired before a value is removed'
	  }, {
	    type: 'fselect.removed',
	    description: 'Fired after a value is removed'
	  }, {
	    type: 'fselect.clearing',
	    description: 'Fired before the value is cleared'
	  }, {
	    type: 'fselect.cleared',
	    description: 'Fired after a value is cleared'
	  }],
	  listeners: [{
	    type: 'fselect.change (type, value, id)',
	    description: 'Makes a change to the value',
	    params: [{
	      name: 'type',
	      type: 'String',
	      description: 'Type of change to make. Valid values are <code>"add"</code>, <code>"remove"</code>, or <code>"clear"</code>'
	    }, {
	      name: 'value',
	      type: 'String',
	      description: 'Value ID to use in the change'
	    }, {
	      name: 'id',
	      type: 'String',
	      description: 'ID of the fselect menu to perform the change on'
	    }]
	  }, {
	    type: 'fselect.add (value, id)',
	    description: 'Sets/Adds a value',
	    params: [{
	      name: 'value',
	      type: 'String',
	      description: 'Value ID to set/add'
	    }, {
	      name: 'id',
	      type: 'String',
	      description: 'ID of the fselect menu to perform the change on'
	    }]
	  }, {
	    type: 'fselect.remove (value, id)',
	    description: 'Removes a value',
	    params: [{
	      name: 'value',
	      type: 'String',
	      description: 'Value ID to remove'
	    }, {
	      name: 'id',
	      type: 'String',
	      description: 'ID of the fselect menu to perform the change on'
	    }]
	  }, {
	    type: 'fselect.clear (id)',
	    description: 'Clears all values',
	    params: [{
	      name: 'id',
	      type: 'String',
	      description: 'ID of the fselect menu to perform the change on'
	    }]
	  }]
	};

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'FTabs',
	  exampleId: 'TabEx1',
	  params: [{
	    name: 'config',
	    type: 'Object&lt;TabConfig&gt;',
	    twoWay: false,
	    required: true,
	    default: null,
	    description: 'Tab configuration object'
	  }, {
	    name: 'active',
	    type: 'String',
	    twoWay: true,
	    required: false,
	    default: 'First Tab',
	    description: 'ID of the active tab'
	  }],
	  events: [{
	    type: 'show.bs.tab',
	    description: 'This event fires before the active tab is changed'
	  }, {
	    type: 'shown.bs.tab',
	    description: 'This event fires after the active tab has changed'
	  }]
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formation = __webpack_require__(72);
	
	var _formation2 = _interopRequireDefault(_formation);
	
	var _ftabs = __webpack_require__(84);
	
	var _ftabs2 = _interopRequireDefault(_ftabs);
	
	var _fmodal = __webpack_require__(71);
	
	var _fmodal2 = _interopRequireDefault(_fmodal);
	
	var _fselect = __webpack_require__(83);
	
	var _fselect2 = _interopRequireDefault(_fselect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  formation: _formation2.default,
	  ftabs: _ftabs2.default,
	  fmodal: _fmodal2.default,
	  fselect: _fselect2.default
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formationConfig = __webpack_require__(81);
	
	var _formationConfig2 = _interopRequireDefault(_formationConfig);
	
	var _formationRowConfig = __webpack_require__(82);
	
	var _formationRowConfig2 = _interopRequireDefault(_formationRowConfig);
	
	var _formationColConfig = __webpack_require__(76);
	
	var _formationColConfig2 = _interopRequireDefault(_formationColConfig);
	
	var _formationColTypeEnum = __webpack_require__(80);
	
	var _formationColTypeEnum2 = _interopRequireDefault(_formationColTypeEnum);
	
	var _formationColTextConfig = __webpack_require__(79);
	
	var _formationColTextConfig2 = _interopRequireDefault(_formationColTextConfig);
	
	var _formationColHtmlConfig = __webpack_require__(77);
	
	var _formationColHtmlConfig2 = _interopRequireDefault(_formationColHtmlConfig);
	
	var _formationColStyledConfig = __webpack_require__(78);
	
	var _formationColStyledConfig2 = _interopRequireDefault(_formationColStyledConfig);
	
	var _formationColButtonConfig = __webpack_require__(73);
	
	var _formationColButtonConfig2 = _interopRequireDefault(_formationColButtonConfig);
	
	var _formationColButtonsConfig = __webpack_require__(74);
	
	var _formationColButtonsConfig2 = _interopRequireDefault(_formationColButtonsConfig);
	
	var _formationColCheckboxConfig = __webpack_require__(75);
	
	var _formationColCheckboxConfig2 = _interopRequireDefault(_formationColCheckboxConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  FormationConfig: _formationConfig2.default,
	  FormationRowConfig: _formationRowConfig2.default,
	  FormationColConfig: _formationColConfig2.default,
	  FormationColTypeEnum: _formationColTypeEnum2.default,
	  FormationColStyledConfig: _formationColStyledConfig2.default,
	  FormationColTextConfig: _formationColTextConfig2.default,
	  FormationColHtmlConfig: _formationColHtmlConfig2.default,
	  FormationColButtonConfig: _formationColButtonConfig2.default,
	  FormationColButtonsConfig: _formationColButtonsConfig2.default,
	  FormationColCheckboxConfig: _formationColCheckboxConfig2.default
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(17);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Multi-Component Form',
	  exampleType: 'formation',
	  description: 'A form that uses multiple components.',
	  headerClass: 'bg-primary',
	  formConfig: {
	    liveValidation: false,
	    rows: [{
	      columns: [{
	        type: 'text',
	        label: 'Text Input',
	        model: 'text'
	      }, {
	        type: 'fselect',
	        label: 'FSelect',
	        model: 'fselect',
	        multiple: true,
	        options: [{ value: 'dog', text: 'Dog' }, { value: 'cat', text: 'Cat' }, { value: 'horse', text: 'Horse' }, { value: 'duck', text: 'Duck' }, { value: 'pig', text: 'Pig' }, { value: 'elephant', text: 'Elephant' }, { value: 'panda', text: 'Panda' }, { value: 'koala', text: 'Koala' }]
	      }]
	    }, {
	      columns: [{
	        type: 'buttons',
	        buttons: [{
	          text: 'Clear',
	          class: 'btn-default',
	          iconClass: 'glyphicon glyphicon-remove',
	          onClick: function onClick(event, vm) {
	            vm.setData('text', '');
	            vm.setData('fselect', []);
	          }
	        }, {
	          text: 'Submit',
	          class: 'btn-primary',
	          iconClass: 'glyphicon glyphicon-ok',
	          onClick: function onClick(event, vm) {
	            if (!vm.validate()) return;
	            vm.$root.$broadcast('modal.show', {
	              title: 'Data',
	              body: '<pre>' + (0, _stringify2.default)(vm.data, null, '  ') + '</pre>',
	              footerButtons: [{
	                content: 'Close',
	                class: 'btn btn-default',
	                onClick: function onClick(event, modal) {
	                  modal.hide();
	                }
	              }]
	            }, 'dialog');
	          }
	        }]
	      }]
	    }]
	  },
	  formData: {
	    text: '',
	    fselect: ''
	  },
	  formHtml: '<formation :data.sync="data" :config="config">'
	};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ex = __webpack_require__(42);
	
	var _ex2 = _interopRequireDefault(_ex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _assign2.default)({}, _ex2.default, {
	  showExample: false,
	  formData: (0, _assign2.default)({}, _ex2.default.formData)
	});

/***/ },
/* 89 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'Modal',
	  showExample: false,
	  exampleType: 'fmodal',
	  description: 'Modal',
	  headerClass: 'bg-primary',
	  formConfig: {
	    title: 'Modal Title',
	    footerButtons: [{
	      content: 'Close',
	      class: 'btn btn-default',
	      onClick: function onClick(event, modal) {
	        modal.hide();
	      }
	    }]
	  },
	  formHtml: '<button type="button" @click="show = true" class="btn btn-primary">\n  Open Modal\n</button>\n<f-modal :show.sync="show" :config="config">\n  <div slot="body">\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  </div>\n</f-modal>'
	};

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  title: 'Tabs',
	  showExample: false,
	  exampleType: 'ftabs',
	  description: 'Simple tabbed content',
	  headerClass: 'bg-primary',
	  formConfig: {
	    tabs: [{
	      id: 'tab1',
	      text: 'Tab 1'
	    }, {
	      id: 'tab2',
	      text: 'Tab 2'
	    }, {
	      id: 'tab3',
	      text: 'Tab 3'
	    }]
	  },
	  formHtml: '<f-tabs :config="config">\n  <div slot="tab1" class="bg-primary">\n    <h3>Tab 1</h3>\n  </div>\n  <div slot="tab2" class="bg-warning">\n    <h3>Tab 2</h3>\n  </div>\n  <div slot="tab3" class="bg-danger">\n    <h3>Tab 3</h3>\n  </div>\n</f-tabs>'
	};

/***/ },
/* 91 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'Ex1': '{\n  "liveValidation":true,\n  "rows":[\n    {\n      "columns":[\n        {\n          "type":"text",\n          "label":"First Name",\n          "model":"firstName",\n          "required":true\n        },\n        {\n          "type":"text",\n          "label":"Last Name",\n          "model":"lastName"\n        }\n      ]\n    },\n    {\n      "columns":[\n        {\n          "type":"buttons",\n          "buttons":[\n            {\n              "text":"Clear",\n              "class":"btn-default",\n              "iconClass":"glyphicon glyphicon-remove",\n              "onClick":(event, vm) => {\n                vm.setData([\'firstName\', \'lastName\'], \'\');\n              }\n            },\n            {\n              "text":"Submit",\n              "class":"btn-primary",\n              "iconClass":"glyphicon glyphicon-ok",\n              "onClick":(event, vm) => {\n                if (!vm.validate()) return;\n                vm.$root.$broadcast(\'modal.show\', {\n                  title: \'Hello!\',\n                  body: \'Welcome \' + vm.data.firstName + \' \' + vm.data.lastName,\n                  footerButtons: [{\n                    content: \'Close\',\n                    class: \'btn btn-default\',\n                    onClick:(event, modal) => {\n                      modal.hide();\n                    }\n                  }]\n                }, \'dialog\');\n              }\n            }\n          ]\n        }\n      ]\n    }\n  ]\n}',
	  'Ex2': '{\n  "liveValidation":false,\n  "rows":[\n    {\n      "columns":[\n        {\n          "type":"text",\n          "label":"Text Input",\n          "model":"text"\n        },\n        {\n          "type":"fselect",\n          "label":"FSelect",\n          "model":"fselect",\n          "multiple":true,\n          "options":[\n            {\n              "value":"dog",\n              "text":"Dog"\n            },\n            {\n              "value":"cat",\n              "text":"Cat"\n            },\n            {\n              "value":"horse",\n              "text":"Horse"\n            },\n            {\n              "value":"duck",\n              "text":"Duck"\n            },\n            {\n              "value":"pig",\n              "text":"Pig"\n            },\n            {\n              "value":"elephant",\n              "text":"Elephant"\n            },\n            {\n              "value":"panda",\n              "text":"Panda"\n            },\n            {\n              "value":"koala",\n              "text":"Koala"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      "columns":[\n        {\n          "type":"buttons",\n          "buttons":[\n            {\n              "text":"Clear",\n              "class":"btn-default",\n              "iconClass":"glyphicon glyphicon-remove",\n              "onClick":(event, vm) => {\n                vm.setData(\'text\', \'\');\n                vm.setData(\'fselect\', []);\n              }\n            },\n            {\n              "text":"Submit",\n              "class":"btn-primary",\n              "iconClass":"glyphicon glyphicon-ok",\n              "onClick":(event, vm) => {\n                if (!vm.validate()) return;\n                vm.$root.$broadcast(\'modal.show\', {\n                  title: \'Data\',\n                  body: \'<pre>\' + (0, _stringify2.default)(vm.data, null, \'  \') + \'</pre>\',\n                  footerButtons: [{\n                    content: \'Close\',\n                    class: \'btn btn-default\',\n                    onClick:(event, modal) => {\n                      modal.hide();\n                    }\n                  }]\n                }, \'dialog\');\n              }\n            }\n          ]\n        }\n      ]\n    }\n  ]\n}',
	  'FormationEx1': '{\n  "liveValidation":true,\n  "rows":[\n    {\n      "columns":[\n        {\n          "type":"text",\n          "label":"First Name",\n          "model":"firstName",\n          "required":true\n        },\n        {\n          "type":"text",\n          "label":"Last Name",\n          "model":"lastName"\n        }\n      ]\n    },\n    {\n      "columns":[\n        {\n          "type":"buttons",\n          "buttons":[\n            {\n              "text":"Clear",\n              "class":"btn-default",\n              "iconClass":"glyphicon glyphicon-remove",\n              "onClick":(event, vm) => {\n                vm.setData([\'firstName\', \'lastName\'], \'\');\n              }\n            },\n            {\n              "text":"Submit",\n              "class":"btn-primary",\n              "iconClass":"glyphicon glyphicon-ok",\n              "onClick":(event, vm) => {\n                if (!vm.validate()) return;\n                vm.$root.$broadcast(\'modal.show\', {\n                  title: \'Hello!\',\n                  body: \'Welcome \' + vm.data.firstName + \' \' + vm.data.lastName,\n                  footerButtons: [{\n                    content: \'Close\',\n                    class: \'btn btn-default\',\n                    onClick:(event, modal) => {\n                      modal.hide();\n                    }\n                  }]\n                }, \'dialog\');\n              }\n            }\n          ]\n        }\n      ]\n    }\n  ]\n}',
	  'TabEx1': '{\n  "tabs":[\n    {\n      "id":"tab1",\n      "text":"Tab 1"\n    },\n    {\n      "id":"tab2",\n      "text":"Tab 2"\n    },\n    {\n      "id":"tab3",\n      "text":"Tab 3"\n    }\n  ]\n}',
	  'ModalEx1': '{\n  "title":"Modal Title",\n  "footerButtons":[\n    {\n      "content":"Close",\n      "class":"btn btn-default",\n      "onClick":(event, modal) => {\n        modal.hide();\n      }\n    }\n  ]\n}'
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ex = __webpack_require__(42);
	
	var _ex2 = _interopRequireDefault(_ex);
	
	var _Ex = __webpack_require__(87);
	
	var _Ex2 = _interopRequireDefault(_Ex);
	
	var _FormationEx = __webpack_require__(88);
	
	var _FormationEx2 = _interopRequireDefault(_FormationEx);
	
	var _TabEx = __webpack_require__(90);
	
	var _TabEx2 = _interopRequireDefault(_TabEx);
	
	var _ModalEx = __webpack_require__(89);
	
	var _ModalEx2 = _interopRequireDefault(_ModalEx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Ex1: _ex2.default,
	  Ex2: _Ex2.default,
	  FormationEx1: _FormationEx2.default,
	  TabEx1: _TabEx2.default,
	  ModalEx1: _ModalEx2.default
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	var _actions = __webpack_require__(16);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  vuex: {
	    actions: {
	      setCollapsed: _actions.setCollapsed
	    },
	    getters: {
	      cookie: function cookie(state) {
	        return state.cookie;
	      }
	    }
	  },
	  methods: {
	    collapse: function collapse(id, section) {
	      var newCollapsed = _.merge({}, _.get(this.cookie, 'collapsed.' + this.tab, {}));
	      newCollapsed[id + '_' + section] = !this.isCollapsed(id, section);
	      this.setCollapsed(this.tab, newCollapsed);
	    },
	    isCollapsed: function isCollapsed(id, section) {
	      return _.get(this.cookie, 'collapsed.' + this.tab, {})[id + '_' + section] === true;
	    }
	  }
	};

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isKey = isKey;
	exports.getKey = getKey;
	var keys = exports.keys = {
	  Escape: 27,
	  Enter: 13,
	  Backspace: 8,
	  ArrowDown: 40,
	  ArrowUp: 38,
	  ArrowRight: 39
	};
	function isKey(evt, key) {
	  if (evt.keyCode === keys[key]) return true;
	  return false;
	}
	
	function getKey(evt) {
	  for (var k in keys) {
	    if (evt.keyCode === keys[k]) return k;
	  }
	}
	
	exports.default = {
	  keys: keys,
	  isKey: isKey
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutations = exports.state = exports.FORMATION_KEY = undefined;
	
	var _stringify = __webpack_require__(17);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FORMATION_KEY = exports.FORMATION_KEY = 'vue-formation';
	
	var cookie = {
	  logoInverted: false,
	  collapsed: {},
	  mainTab: 'about',
	  theme: 'https://cdnjs.cloudflare.com/ajax/libs/bootswatch/3.3.6/paper/bootstrap.min.css',
	  themes: [{
	    value: 'customurl',
	    text: 'Custom URL'
	  }, {
	    value: null,
	    text: 'Bootstrap'
	  }, {
	    value: 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.6/css/bootstrap-theme.css',
	    text: 'Bootstrap Theme'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/flatly/bootstrap.min.css',
	    text: 'Flatly'
	  }, {
	    value: 'https://cdnjs.cloudflare.com/ajax/libs/bootswatch/3.3.6/paper/bootstrap.min.css',
	    text: 'Paper'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/cerulean/bootstrap.min.css',
	    text: 'Cerulean'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/cosmo/bootstrap.min.css',
	    text: 'Cosmo'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/cyborg/bootstrap.min.css',
	    text: 'Cyborg'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/darkly/bootstrap.min.css',
	    text: 'Darkly'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/journal/bootstrap.min.css',
	    text: 'Journal'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/lumen/bootstrap.min.css',
	    text: 'Lumen'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/readable/bootstrap.min.css',
	    text: 'Readable'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/sandstone/bootstrap.min.css',
	    text: 'Sandstone'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/simplex/bootstrap.min.css',
	    text: 'Simplex'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/slate/bootstrap.min.css',
	    text: 'Slate'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/spacelab/bootstrap.min.css',
	    text: 'Spacelab'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/superhero/bootstrap.min.css',
	    text: 'Superhero'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/united/bootstrap.min.css',
	    text: 'United'
	  }, {
	    value: 'https://maxcdn.bootstrapcdn.com/bootswatch/3.3.6/yeti/bootstrap.min.css',
	    text: 'Yeti'
	  }]
	};
	
	function parseCookie() {
	  var localCookie = localStorage.getItem(FORMATION_KEY);
	  if (localCookie) {
	    try {
	      return JSON.parse(localCookie);
	    } catch (err) {}
	  }
	  return cookie;
	}
	function setCookie(state, data) {
	  try {
	    localStorage.setItem(FORMATION_KEY, (0, _stringify2.default)(data));
	    state.cookie = data;
	  } catch (err) {}
	}
	
	var state = exports.state = {
	  cookie: JSON.parse(localStorage.getItem(FORMATION_KEY)) || cookie
	};
	
	var mutations = exports.mutations = {
	  CHANGE_THEME: function CHANGE_THEME(state, theme) {
	    var data = parseCookie();
	    data.theme = theme;
	    setCookie(state, data);
	  },
	  CUSTOM_THEME: function CUSTOM_THEME(state, theme) {
	    var data = parseCookie();
	    var found = _.find(data.themes, function (t) {
	      return t.value === theme;
	    });
	    var customs = _.filter(data.themes, function (t) {
	      return Array.isArray(t.text.match(/^Custom[0-9]]/));
	    });
	    if (!found) {
	      data.themes.push({
	        text: 'Custom' + (customs.length + 1),
	        value: theme
	      });
	    }
	    setCookie(state, data);
	  },
	  CHANGE_INVERTED_LOGO: function CHANGE_INVERTED_LOGO(state, inverted) {
	    var data = parseCookie();
	    data.logoInverted = inverted;
	    setCookie(state, data);
	  },
	  ACTIVATE_MAIN_TAB: function ACTIVATE_MAIN_TAB(state, tab) {
	    var data = parseCookie();
	    data.mainTab = tab;
	    setCookie(state, data);
	  },
	  SET_COLLAPSED: function SET_COLLAPSED(state, tab, collapsed) {
	    var data = parseCookie();
	    data.collapsed = data.collapsed || {};
	    data.collapsed[tab] = collapsed;
	    setCookie(state, data);
	  }
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _prismjs = __webpack_require__(167);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _Main = __webpack_require__(238);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _HeadCss = __webpack_require__(237);
	
	var _HeadCss2 = _interopRequireDefault(_HeadCss);
	
	var _store = __webpack_require__(46);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(156);
	
	__webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_prismjs2.default.languages.flowtype = _prismjs2.default.languages.extend('javascript', {});
	
	exports.default = {
	  store: _store2.default,
	  components: { Main: _Main2.default, HeadCss: _HeadCss2.default },
	  created: function created() {
	    var Languages = {};
	    _prismjs2.default.hooks.add('before-highlight', function (env) {
	      var pre = env.element.parentNode;
	      if (!pre || !/pre/i.test(pre.nodeName)) {
	        return;
	      }
	      if (env.element.classList.contains('no-language-label')) return;
	      var language = pre.getAttribute('data-language') || Languages[env.language] || env.language.substring(0, 1).toUpperCase() + env.language.substring(1);
	
	      var langOverride = env.element.getAttribute('data-language-override');
	
	      var sib = pre.previousSibling;
	      var div, div2;
	      if (sib && /\s*\bprism-show-language\b\s*/.test(sib.className) && sib.firstChild && /\s*\bprism-show-language-label\b\s*/.test(sib.firstChild.className)) {
	        div2 = sib.firstChild;
	      } else {
	        div = document.createElement('div');
	        div2 = document.createElement('div');
	        div2.className = 'prism-show-language-label';
	        div.className = 'prism-show-language';
	        div.appendChild(div2);
	        pre.parentNode.insertBefore(div, pre);
	      }
	      div2.innerHTML = langOverride || language;
	    });
	    this.$nextTick(function () {
	      _prismjs2.default.highlightAll();
	    });
	  }
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Collapse = __webpack_require__(93);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_Collapse2.default],
	  props: {
	    header: { type: String },
	    typeId: { type: String, required: true },
	    section: { type: String, required: true },
	    tab: { type: String, required: true }
	  }
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docs = __webpack_require__(85);
	
	var _docs2 = _interopRequireDefault(_docs);
	
	var _TypeLinks = __webpack_require__(43);
	
	var _TypeLinks2 = _interopRequireDefault(_TypeLinks);
	
	var _components = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_TypeLinks2.default],
	  components: {
	    Formation: _components.Formation,
	    FTabs: _components.FTabs,
	    FModal: _components.FModal
	  },
	  props: {
	    vm: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      Docs: _docs2.default,
	      show: false
	    };
	  }
	};

/***/ },
/* 99 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      opener: false,
	      open: false
	    };
	  },
	
	  methods: {
	    isFunction: function isFunction(obj) {
	      return typeof obj === 'function';
	    },
	    clickAway: function clickAway(event) {
	      if (this.$els && this.$els.content && !this.$els.content.contains(event.target) && this.open) this.hideModal();
	    },
	    toggleModal: function toggleModal() {
	      this.show = !this.show;
	    },
	    toggle: function toggle() {
	      this.toggleModal();
	    },
	    hideModal: function hideModal(noSet) {
	      if (this.opener) return;
	      this.$emit('modal.closing');
	      this.$emit('hide.bs.modal');
	      if (!noSet) this.show = false;
	    },
	    hide: function hide() {
	      this.hideModal();
	    },
	    showModal: function showModal(noSet) {
	      this.opener = true;
	      this.$emit('modal.opening');
	      this.$emit('show.bs.modal');
	      if (this.exclusive) this.$root.$broadcast('modal.hide');
	      if (!noSet) this.show = true;
	    }
	  },
	  props: {
	    show: {
	      twoWay: true,
	      type: Boolean,
	      default: false
	    },
	    config: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    modalId: {
	      type: String
	    },
	    backdrop: {
	      type: Boolean,
	      default: true
	    },
	    backdropOpacity: {
	      type: Number,
	      default: 0.5
	    },
	    exclusive: {
	      type: Boolean,
	      default: true
	    },
	    zIndex: {
	      type: Number,
	      default: 2000000000
	    },
	    animation: {
	      type: String,
	      default: 'fade-modal'
	    }
	  },
	  watch: {
	    show: function show(val) {
	      val ? this.showModal(true) : this.hideModal(true);
	    }
	  },
	  events: {
	    'modal.hide': function modalHide() {
	      this.hideModal();
	    },
	    'modal.show': function modalShow(config, id) {
	      if (id && this.modalId !== id) return;
	      this.config = config || this.config;
	      this.showModal();
	    },
	    'modal.opening': function modalOpening() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.$emit('modal.open');
	      }, 0);
	    },
	    'modal.open': function modalOpen() {
	      this.open = true;
	      this.opener = false;
	      this.$emit('shown.bs.modal');
	    },
	    'modal.closing': function modalClosing() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.$emit('modal.close');
	      }, 0);
	    },
	    'modal.close': function modalClose() {
	      this.open = false;
	      this.$emit('hidden.bs.modal');
	    }
	  }
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	var _helpers = __webpack_require__(44);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _events = __webpack_require__(94);
	
	__webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function validateClassProp(value) {
	  return _.isString(value) || _.isArray(value) || _.isHash(value);
	}
	
	function validateValue(value) {
	  return value || value === 0;
	}
	
	exports.default = {
	  data: function data() {
	    return {
	      open: false,
	      removeClickAway: function removeClickAway() {},
	      search: '',
	      searchResults: [],
	      activeOption: 0
	    };
	  },
	
	  methods: {
	    emitChange: function emitChange(type, value, id) {
	      this.$emit('fselect.change', type, value, id);
	    },
	    addItem: function addItem(id) {
	      var val = this.getValue(id);
	      var found = _.contains(this.value, val);
	      if (this.value.length >= this.selectLimit && !found) {
	        this.$dispatch('fselect.error', {
	          message: 'The maximum selected option limit of ' + this.selectLimit + ' has been reached'
	        });
	        return;
	      } else if (this.multiple) {
	        if (this.allowMultiple || !this.allowMultiple && !found) {
	          this.value.push(val);
	          this.$emit('fselect.added', val);
	          this.$emit('fselect.changed');
	          if (this.onChange) this.onChange('add', val, this);
	          this.closeDropdown();
	        } else {
	          this.removeItem(id);
	        }
	      } else {
	        this.value = [val];
	        this.$emit('fselect.added', val);
	        this.$emit('fselect.changed');
	        if (this.onChange) this.onChange('add', val, this);
	        this.closeDropdown();
	      }
	    },
	    closeDropdown: function closeDropdown(force) {
	      if (this.closeOnSelect || force) {
	        this.open = false;
	        this.search = '';
	      }
	    },
	    clearItems: function clearItems() {
	      if (this.multiple && this.allowClear) this.value = [];
	      this.$emit('fselect.cleared');
	      this.$emit('fselect.changed');
	      if (this.onChange) this.onChange('clear', undefined, this);
	    },
	    removeItem: function removeItem(id) {
	      var _this = this;
	
	      this.value = _.filter(this.value, function (v) {
	        return _this.storeObject && v[_this.valueKey] !== id || !_this.storeObject && v !== id;
	      });
	      this.$emit('fselect.removed', id);
	      this.$emit('fselect.changed');
	      if (this.onChange) this.onChange('remove', id, this);
	    },
	    clickAway: function clickAway(event) {
	      if (this.$el && !this.$el.contains(event.target) && this.open) this.closeDropdown(true);
	    },
	    getValue: function getValue(id) {
	      var _this2 = this;
	
	      return !this.storeObject ? id : _.find(this.options, function (v) {
	        return v[_this2.valueKey] === id;
	      });
	    },
	    isSelected: function isSelected(opt) {
	      var _this3 = this;
	
	      var ids = _.map(this.value, function (v) {
	        return _this3.storeObject ? v[_this3.valueKey] : v;
	      });
	      return _.contains(ids, opt[this.valueKey]);
	    },
	    searchHandler: function searchHandler(event) {
	      if ((0, _events.isKey)(event, 'ArrowDown') && this.activeOption < this.searchResults.length - 1) {
	        this.activeOption++;
	      } else if ((0, _events.isKey)(event, 'ArrowUp') && this.activeOption > 0) {
	        this.activeOption--;
	      } else if ((0, _events.isKey)(event, 'Enter')) {
	        event.preventDefault();
	        var item = this.searchResults[this.activeOption];
	        if (item) this.emitChange('add', item[this.valueKey], this.selectId);
	      } else if ((0, _events.isKey)(event, 'Escape')) {
	        this.closeDropdown(true);
	      } else {
	        this.activeOption = 0;
	      }
	    },
	    toggleDropdown: function toggleDropdown(event) {
	      var _this4 = this;
	
	      var clickAreas = [this.$els.selectcontainer, this.$els.selectbody, this.$els.placeholder];
	      if (_.contains(clickAreas, event.target)) this.open = !this.open;
	      if (this.open && this.searchable) {
	        this.$nextTick(function () {
	          _this4.$els.search.focus();
	        });
	      }
	    }
	  },
	  computed: {
	    interactClass: function interactClass() {
	      if (!this.disabled) {
	        if (!this.multiple || !this.value.length) {
	          return this.caretClass;
	        } else if (this.allowClear && this.value.length > 0) {
	          return this.removeClass;
	        }
	      }
	      return null;
	    },
	    multiValue: function multiValue() {
	      var _this5 = this;
	
	      return this.storeObject ? this.value : _.map(this.value, function (val) {
	        return _.find(_this5.options, function (opt) {
	          return opt[_this5.valueKey] === val;
	        });
	      });
	    },
	    multiValueText: function multiValueText() {
	      var _this6 = this;
	
	      return _.map(_.filter(this.options, function (opt) {
	        return _.find(_this6.value, function (val) {
	          var v = _this6.storeObject ? val[_this6.valueKey] : val;
	          return opt[_this6.valueKey] === v;
	        });
	      }), function (val) {
	        return val[_this6.textKey];
	      }).join(', ');
	    },
	    singleValueText: function singleValueText() {
	      var _this7 = this;
	
	      return _.get(_.find(this.options, function (opt) {
	        var v = _this7.storeObject ? _this7.value[0][_this7.valueKey] : _this7.value[0];
	        return opt[_this7.valueKey] === v;
	      }), this.textKey);
	    }
	  },
	  filters: {
	    selectable: function selectable(options) {
	      var _this8 = this;
	
	      var newOptions = _.filter(options, function (opt) {
	        try {
	          return opt[_this8.textKey].match(new RegExp(_this8.search, 'i')) || _this8.search === '';
	        } catch (err) {
	          return false;
	        }
	      });
	      this.searchResults = newOptions.slice(0, this.optionLimit);
	      return newOptions.slice(0, this.optionLimit);
	    }
	  },
	  props: {
	    align: { type: String, default: 'left' },
	    allowClear: { type: Boolean, default: true },
	    allowMultiple: { type: Boolean, default: false },
	    caretClass: { validator: validateClassProp, default: 'icon formation-caret-down caret-font' },
	    closeOnSelect: { type: Boolean, default: true },
	    disabled: { type: Boolean, default: false },
	    optionLimit: { type: Number, default: 5 },
	    multiple: { type: Boolean, default: false },
	    onChange: { type: Function },
	    onChanging: { type: Function, default: function _default() {
	        return true;
	      } },
	    options: { type: Array, required: true },
	    placeholder: { type: String, default: '' },
	    removeClass: { validator: validateClassProp, default: 'icon formation-remove x-remove' },
	    removeSelectedOptions: { type: Boolean, default: false },
	    searchable: { type: Boolean, default: true },
	    selectId: { type: String },
	    storeObject: { type: Boolean, default: false },
	    tagClass: {
	      validator: validateClassProp,
	      default: function _default() {
	        return ['btn', 'btn-primary', 'default-tag-class'];
	      }
	    },
	    textKey: { type: String, default: 'text' },
	    value: { twoWay: true, validator: validateValue },
	    valueKey: { type: String, default: 'value' },
	    width: {
	      validator: function validator(value) {
	        var rx = /(^100%$)|^[1-9]\d?%$/;
	        return !isNaN(value) || String(value).match(rx);
	      }
	    }
	  },
	  created: function created() {
	    var _this9 = this;
	
	    this.removeClickAway = (0, _helpers2.default)(document).click(this.clickAway, undefined, true);
	    this.value = _.without(_.map(_.ensureArray(this.value), function (v) {
	      return _this9.getValue(_.isString(v) ? v : _.get(v, _this9.valueKey, null));
	    }), null);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.removeClickAway();
	  },
	
	  events: {
	    'fselect.change': function fselectChange(type, value, id) {
	      if (this.selectId && this.selectId !== id) return;
	
	      this.$emit('fselect.changing', type, value, this, id);
	      if (this.onChanging(type, value, this)) {
	        switch (type) {
	          case 'add':
	            this.$emit('fselect.adding', value, this, id);
	            this.addItem(value);
	            break;
	          case 'remove':
	            this.$emit('fselect.removing', value, this, id);
	            this.removeItem(value);
	            break;
	          case 'clear':
	            this.$emit('fselect.clearing', this, id);
	            this.clearItems();
	            break;
	          default:
	            break;
	        }
	      }
	    },
	    'fselect.add': function fselectAdd(value, id) {
	      this.$emit('fselect.change', 'add', value, id);
	    },
	    'fselect.remove': function fselectRemove(value, id) {
	      this.$emit('fselect.change', 'remove', value, id);
	    },
	    'fselect.clear': function fselectClear(id) {
	      this.$emit('fselect.change', 'clear', id);
	    }
	  }
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  methods: {
	    activate: function activate(id) {
	      var _this = this;
	
	      this.$emit('show.bs.tab', id);
	      if (this.active !== id) this.active = id;
	      this.$nextTick(function () {
	        _this.$emit('shown.bs.tab', id);
	        if (typeof _this.config.onActivate === 'function') _this.config.onActivate(id, _this);
	      });
	    }
	  },
	  created: function created() {
	    if (!this.active) this.active = _.get(this.config, 'tabs[0].id');
	  },
	
	  props: {
	    active: {
	      twoWay: true,
	      type: String
	    },
	    config: {
	      type: Object,
	      required: true
	    }
	  }
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(17);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	var _helpers = __webpack_require__(44);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _FSelect = __webpack_require__(68);
	
	var _FSelect2 = _interopRequireDefault(_FSelect);
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    fSelect: _FSelect2.default
	  },
	  methods: {
	    breakOp: function breakOp() {
	      if (this.config.debug) {
	        if (this.opCount > this.opMax) return true;
	        this.opCount++;
	      }
	      return false;
	    },
	    clearData: function clearData(path, onNextTick) {
	      this.setData(path, undefined, onNextTick);
	    },
	    setData: function setData(path, value, onNextTick) {
	      var _this = this;
	
	      var doClear = function doClear() {
	        path = _.ensureArray(path);
	        _.forEach(path, function (p) {
	          var pathRx = _.escapeRegExp(p);
	          _.forEach(_this.formData, function (val, key) {
	            if (key.match(pathRx)) {
	              _this.formData[key] = value;
	            }
	          });
	        });
	      };
	      onNextTick ? this.$nextTick(doClear) : doClear();
	    },
	    multiClickaway: function multiClickaway(evt) {
	      this.$broadcast('hide::dropdown');
	    },
	    formDisabled: function formDisabled() {
	      if (_.isFunction(this.config.disabled)) return this.config.disabled();
	      if (_.isBoolean(this.config.disabled)) return this.config.disabled;
	      return null;
	    },
	    pretty: function pretty(obj) {
	      var label = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	      try {
	        console.log(label, (0, _stringify2.default)(obj, null, '  '));
	      } catch (err) {}
	    },
	    has: function has(obj, path) {
	      return _.has(obj, path);
	    },
	    isTextInput: function isTextInput(type) {
	      return this.textTypes.indexOf(type) !== -1;
	    },
	    isButtonType: function isButtonType(type) {
	      return this.buttonTypes.indexOf(type) !== -1;
	    },
	    isTopLabeled: function isTopLabeled(type) {
	      return this.noTopLabel.indexOf(type) === -1;
	    },
	    getLabel: function getLabel(rIdx, cIdx, label) {
	      var labelCount = 0;
	      var row = _.get(this.formConfig, '[' + rIdx + ']', []);
	      _.forEach(row.columns, function (col, idx) {
	        var lbl = _.get(col, 'label', null);
	        if (lbl) labelCount++;
	      });
	      if (!labelCount) return null;
	      if (labelCount && !label) return '&nbsp;';
	      return label;
	    },
	    formId: function formId(rowIndex, formIndex) {
	      return this.$get('uuid').concat('r').concat(rowIndex).concat('f').concat(formIndex);
	    },
	    formGroupId: function formGroupId(rIdx, fIdx) {
	      return this.formId(rIdx, fIdx).concat('_group');
	    },
	    formGroup: function formGroup(rIdx, fIdx) {
	      return (0, _helpers2.default)('#'.concat(this.formGroupId(rIdx, fIdx)));
	    },
	    colClass: function colClass(columns, rIdx, fIdx, path) {
	      var cols = Math.floor(12 / columns.length);
	      if (fIdx === 0) cols += 12 % columns.length;
	      var classes = [];
	      if (!this.isTopLabeled(columns[fIdx].type)) {
	        classes.push('focused');
	        classes.push('blured');
	      }
	      if (this.config.floatingLabels) classes.push('label-floating');
	      classes.push('col-xs-'.concat(cols));
	      classes.push('col-sm-'.concat(cols));
	      classes.push('col-md-'.concat(cols));
	      classes.push('col-lg-'.concat(cols));
	      return classes;
	    },
	    calcProgress: function calcProgress() {
	      var _this2 = this;
	
	      var requiredCount = 0;
	      var requiredFilled = 0;
	      this.valid = true;
	      _.forEach(this.formConfig, function (row, rIdx) {
	        _.forEach(row.columns, function (form, fIdx) {
	          var data = _.get(_this2.formData, form.model);
	          var valid = _.isFunction(form.validate) ? form.validate(data) : true;
	          if (!valid) {
	            _this2.valid = false;
	            if (_this2.config.liveValidation && _this2.touched) _this2.formGroup(rIdx, fIdx).addClass('has-error');
	          } else {
	            _this2.formGroup(rIdx, fIdx).removeClass('has-error');
	          }
	          if (form.required) {
	            requiredCount++;
	            if (valid && data) requiredFilled++;
	          }
	        });
	      });
	      this.touched = true;
	      if (!requiredCount) return 100;
	      return Math.floor(requiredFilled / requiredCount * 100);
	    },
	    validate: function validate() {
	      var _this3 = this;
	
	      this.valid = true;
	      this.touched = true;
	      _.forEach(this.formConfig, function (row, rIdx) {
	        _.forEach(row.columns, function (form, fIdx) {
	          var data = _.get(_this3.formData, form.model);
	          var valid = _.isFunction(form.validate) ? form.validate(data) : true;
	          if (!valid || form.required && !data) {
	            _this3.valid = false;
	            _this3.formGroup(rIdx, fIdx).addClass('has-error');
	          } else {
	            _this3.formGroup(rIdx, fIdx).removeClass('has-error');
	          }
	        });
	      });
	      return this.valid;
	    },
	    updateSource: function updateSource() {
	      var _this4 = this;
	
	      if (this.breakOp()) return;
	      this.pauseWatch = true;
	      var paths = [];
	      var progress = this.calcProgress();
	      if (this.config.progress) {
	        var progKey = this.config.progress === true ? '$$progress' : this.config.progress;
	        _vue2.default.set(this.data, progKey, progress);
	      }
	      _.forEach(this.formConfig, function (row) {
	        _.forEach(row.columns, function (col) {
	          if (_this4.formData[col.model] !== undefined) {
	            paths.push(col.model);
	            _.vueSet(_this4.data, col.model, _this4.formData[col.model]);
	          }
	        });
	      });
	      _.forEach(this.formData, function (d, k) {
	        if (!_.includes(paths, k)) delete _this4.formData[k];
	      });
	      this.$nextTick(function () {
	        _this4.pauseWatch = false;
	      });
	    },
	    updateLocal: function updateLocal() {
	      var _this5 = this;
	
	      if (this.breakOp()) return;
	      this.pauseWatch = true;
	      _.forEach(this.formConfig, function (row) {
	        _.forEach(row.columns, function (form) {
	          if (_.has(_this5.data, form.model)) {
	            var val = _.get(_this5.data, form.model);
	            _vue2.default.set(_this5.formData, form.model, val);
	          }
	        });
	      });
	      this.$nextTick(function () {
	        _this5.pauseWatch = false;
	      });
	    }
	  },
	  computed: {
	    utils: function utils() {
	      return (0, _assign2.default)({
	        setData: this.setData,
	        clearData: this.clearData,
	        validate: this.validate,
	        data: this.data,
	        config: (0, _assign2.default)({}, this.config, { rows: this.formConfig }),
	        localData: this.formData
	      }, _);
	    },
	    formConfig: function formConfig() {
	      var _this6 = this;
	
	      var rows = [];
	      _.forEach(this.config.rows, function (row) {
	        if (row.type === 'include') {
	          var newRows = _.isFunction(row.value) ? row.value(row, _this6) : row.value;
	          if (_.isArray(newRows)) {
	            _.forEach(newRows, function (r) {
	              rows.push(r);
	            });
	          }
	        } else {
	          rows.push(row);
	        }
	      });
	      return rows;
	    },
	    isBootstrapFormat: function isBootstrapFormat() {
	      return !this.config || !this.config.style || this.config.framework === 'bootstrap';
	    }
	  },
	  data: function data() {
	    return {
	      opMax: 50,
	      opCount: 0,
	      lastConfig: [],
	      valid: true,
	      touched: false,
	      pauseWatch: false,
	      formData: {},
	      uuid: null,
	      textTypes: ['text', 'email', 'password', 'number', 'search', 'url', 'tel'],
	      dateTypes: ['date', 'month', 'week', 'time', 'datetime', 'datetime-local'],
	      uiTypes: ['radio', 'checkbox', 'color', 'range'],
	      buttonTypes: ['button', 'submit'],
	      noTopLabel: ['checkbox', 'button', 'radio', 'toggle', 'select', 'multiselect', 'select2', 'html']
	    };
	  },
	  created: function created() {
	    this.uuid = 'form_' + Date.now();
	    this.updateLocal();
	  },
	
	  watch: {
	    formData: {
	      handler: function handler() {
	        if (this.pauseWatch) return;
	        this.updateSource();
	      },
	
	      deep: true
	    },
	    data: {
	      handler: function handler() {
	        if (this.pauseWatch) return;
	        this.updateLocal();
	      },
	
	      deep: true
	    },
	    opCount: function opCount(v) {
	      console.log(v);
	    }
	  },
	  props: {
	    config: { type: Object, required: true },
	    data: { twoWay: true, type: Object, required: true },
	    width: {
	      validator: function validator(val) {
	        return typeof val === 'number' || typeof val === 'string';
	      }
	    }
	  },
	  events: {
	    'fselect.error': function fselectError(event) {
	      this.$dispatch('formation.error', _.merge({ from: 'fselect' }, event));
	    }
	  }
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(16);
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  vuex: {
	    actions: {
	      changeTheme: _actions.changeTheme,
	      changeInvertedLogo: _actions.changeInvertedLogo
	    },
	    getters: {
	      cookie: function cookie(state) {
	        return state.cookie;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      color: null,
	      intervalCount: 0,
	      interval: null
	    };
	  },
	
	  methods: {
	    parseColor: function parseColor(color) {
	      var arr = [];
	      color.replace(/[\d+\.]+/g, function (v) {
	        arr.push(parseFloat(v));
	      });
	      return {
	        hex: '#' + arr.slice(0, 3).map(this.toHex).join(''),
	        opacity: arr.length === 4 ? arr[3] : 1
	      };
	    },
	    toHex: function toHex(int) {
	      var hex = int.toString(16);
	      return hex.length === 1 ? '0' + hex : hex;
	    },
	    getContrastYIQ: function getContrastYIQ(hexcolor) {
	      var opacity = 1;
	      if (hexcolor.match(/^rgb/)) {
	        var convert = this.parseColor(hexcolor);
	        hexcolor = convert.hex;
	        opacity = Number(convert.opacity);
	      }
	
	      hexcolor = hexcolor.replace(/^#/, '');
	      var r = parseInt(hexcolor.substr(0, 2), 16);
	      var g = parseInt(hexcolor.substr(2, 2), 16);
	      var b = parseInt(hexcolor.substr(4, 2), 16);
	      var yiq = (r * 299 + g * 587 + b * 114) / (1000 * opacity);
	      return yiq >= 128 ? '#000' : '#fff';
	    },
	    getColor: function getColor() {
	      var el = document.getElementById('topnav');
	      var bgColor = window.getComputedStyle(el).getPropertyValue('background-color');
	      return this.getContrastYIQ(bgColor);
	    },
	    removeInterval: function removeInterval() {
	      clearInterval(this.interval);
	      this.interval = null;
	    }
	  },
	  events: {
	    'theme.set': function themeSet(theme) {
	      var _this = this;
	
	      if (this.interval) {
	        this.removeInterval();
	        this.interval = null;
	      }
	      var intervalCount = 0;
	      this.changeTheme(theme);
	
	      setTimeout(function () {
	        _this.interval = setInterval(function () {
	          if (intervalCount > 200) _this.removeInterval();
	          intervalCount++;
	          var found = _.find(document.styleSheets, function (sheet) {
	            if (sheet.href === theme) return true;
	          });
	          if (found) {
	            _this.removeInterval();
	            _this.changeInvertedLogo(_this.getColor() === '#fff');
	          }
	        }, 10);
	      }, 100);
	    }
	  }
	};

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      msg: 'Hello World!'
	    };
	  }
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(18);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	var _stringify = __webpack_require__(45);
	
	var _examples = __webpack_require__(92);
	
	var _examples2 = _interopRequireDefault(_examples);
	
	var _exampleConfigStrings = __webpack_require__(91);
	
	var _exampleConfigStrings2 = _interopRequireDefault(_exampleConfigStrings);
	
	var _About = __webpack_require__(231);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _ComponentsDoc = __webpack_require__(233);
	
	var _ComponentsDoc2 = _interopRequireDefault(_ComponentsDoc);
	
	var _TypesDoc = __webpack_require__(239);
	
	var _TypesDoc2 = _interopRequireDefault(_TypesDoc);
	
	var _Hello = __webpack_require__(69);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _ThemeSelector = __webpack_require__(70);
	
	var _ThemeSelector2 = _interopRequireDefault(_ThemeSelector);
	
	var _index = __webpack_require__(41);
	
	var _actions = __webpack_require__(16);
	
	__webpack_require__(153);
	
	__webpack_require__(154);
	
	__webpack_require__(166);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  vuex: {
	    actions: {
	      activateMainTab: _actions.activateMainTab
	    },
	    getters: {
	      cookie: function cookie(state) {
	        return state.cookie;
	      }
	    }
	  },
	  components: {
	    About: _About2.default,
	    ComponentsDoc: _ComponentsDoc2.default,
	    TypesDoc: _TypesDoc2.default,
	    Hello: _Hello2.default,
	    Formation: _index.Formation,
	    FModal: _index.FModal,
	    FTabs: _index.FTabs,
	    ThemeSelector: _ThemeSelector2.default
	  },
	  created: function created() {
	    var _this = this;
	
	    this.mainTabActive = this.cookie.mainTab;
	    _.forEach(_examples2.default, function (example, id) {
	      _.vueSet(_this.exampleData, id, example.formData);
	      _.vueSet(_this.exampleConfig, id, example.formConfig);
	    });
	  },
	
	  events: {
	    'formation.error': function formationError(evt) {
	      console.log(evt);
	    }
	  },
	  methods: {
	    showCode: function showCode(id) {
	      var config = {
	        footerButtons: [{
	          content: 'Close',
	          class: 'btn btn-default',
	          onClick: function onClick(event, modal) {
	            modal.hide();
	          }
	        }]
	      };
	      var exConfig = this.Examples[id];
	      if (!exConfig) {
	        config = (0, _assign2.default)({
	          title: 'No Documentation',
	          body: 'There is currently no documentation available for this example',
	          headerClass: 'bg-warning',
	          headerIconClass: 'fa fa-warning'
	        }, config);
	      } else {
	        this.source.config = _exampleConfigStrings2.default[id];
	        this.source.data = (0, _stringify.stringify)(this.exampleData[id], null, '  ');
	        this.source.html = exConfig.formHtml;
	        if (exConfig.exampleType !== 'formation') this.sourceTabConfig.tabs[1].show = false;else this.sourceTabConfig.tabs[1].show = true;
	        config = (0, _assign2.default)(config, exConfig);
	      }
	      this.$refs.codemodal.$emit('modal.show', config);
	    }
	  },
	  computed: _.merge({}, _.mapValues(_examples2.default, function (v) {
	    return function () {
	      return v.formConfig;
	    };
	  })),
	  data: function data() {
	    var _this2 = this;
	
	    var self = this;
	    return {
	      self: self,
	      customUrl: 'http://',
	      customUrlError: false,
	      exampleData: {},
	      exampleConfig: {},
	      sourceTabConfig: {
	        tabs: [{ id: 'config', text: 'Configuration Object' }, { id: 'data', text: 'Data Object' }, { id: 'html', text: 'HTML' }]
	      },
	      mainTabConfig: {
	        onActivate: function onActivate(id) {
	          _this2.activateMainTab(id);
	        },
	        tabs: [{ id: 'about', text: 'About' }, { id: 'examples', text: 'Examples' }, { id: 'components', text: 'Components' }, { id: 'types', text: 'Types' }]
	      },
	      source: {
	        config: null,
	        data: null,
	        html: null
	      },
	      exActiveTabs: {},
	      mainTabActive: null,
	      sourceTabActive: 'config',
	      Examples: _examples2.default
	    };
	  }
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validator = __webpack_require__(170);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _actions = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  vuex: {
	    actions: {
	      customTheme: _actions.customTheme
	    },
	    getters: {
	      cookie: function cookie(state) {
	        return state.cookie;
	      }
	    }
	  },
	  created: function created() {
	    this.value = this.cookie.theme;
	  },
	
	  methods: {
	    onChange: function onChange(event) {
	      var _this = this;
	
	      if (this.value === 'customurl') {
	        this.$root.$broadcast('modal.show', {
	          title: 'Custom Theme URL',
	          headerClass: 'bg-primary',
	          footerButtons: [{
	            content: 'Cancel',
	            class: 'btn btn-default',
	            onClick: function onClick(event, modal) {
	              _this.value = _this.lastValue;
	              modal.hide();
	            }
	          }, {
	            content: 'Set',
	            class: 'btn btn-primary',
	            onClick: function onClick(event, modal) {
	              if (_validator2.default.isURL(_this.$parent.customUrl)) {
	                _this.$parent.customUrlError = false;
	
	                _this.customTheme(_this.$parent.customUrl);
	                _this.value = _this.$parent.customUrl;
	                _this.$root.$broadcast('theme.set', _this.value);
	                modal.hide();
	              } else {
	                _this.$parent.customUrlError = true;
	              }
	            }
	          }]
	        }, 'theme-selector');
	      } else {
	        this.$root.$broadcast('theme.set', this.value);
	      }
	    }
	  },
	  watch: {
	    value: function value(newVal, oldVal) {
	      if (newVal !== this.lastValue) this.lastValue = oldVal;
	    }
	  },
	  data: function data() {
	    return {
	      customCount: 0,
	      lastValue: null,
	      value: null,
	      options: []
	    };
	  }
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _types = __webpack_require__(86);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _TypeLinks = __webpack_require__(43);
	
	var _TypeLinks2 = _interopRequireDefault(_TypeLinks);
	
	var _CollapsableSection = __webpack_require__(232);
	
	var _CollapsableSection2 = _interopRequireDefault(_CollapsableSection);
	
	var _utils = __webpack_require__(2);
	
	var _ = _interopRequireWildcard(_utils);
	
	var _stringify2 = __webpack_require__(45);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_TypeLinks2.default],
	  components: {
	    CollapsableSection: _CollapsableSection2.default
	  },
	  methods: {
	    stringify: function stringify(obj) {
	      return (0, _stringify2.stringify)(obj, null, '  ');
	    },
	    getInherited: function getInherited(type) {
	      var rows = [];
	      var getNest = function getNest(parent) {
	        var l = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	        var keys = _.map(_.get(_types2.default, parent + '.structure', {}), function (t) {
	          return t.path;
	        }).sort();
	        l.push({ parent: parent, keys: keys });
	        var newParent = _.get(_types2.default, parent + '.extends');
	        if (newParent) getNest(newParent, l);
	        return l;
	      };
	      _.forEach(getNest(type), function (n) {
	        rows.push('Properties inherited from <a href="#' + n.parent + '">' + n.parent + '</a>');
	        rows.push(_.map(n.keys, function (v) {
	          return '<a>' + v + '</a>';
	        }).join(', '));
	      });
	      return rows;
	    }
	  },
	  data: function data() {
	    return {
	      tab: 'types',
	      Types: _types2.default
	    };
	  }
	};

/***/ },
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 154 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 155 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 156 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 157 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 158 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 159 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 160 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 161 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 162 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 163 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 164 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 165 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 166 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 167 */,
/* 168 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 169 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ function(module, exports) {

	module.exports = " <h3>Introduction</h3> <h4 class=text-primary><span class=\"fa fa-hashtag\"></span> About</h4> <div class=well style=\"border: 1px solid #ddd; border-radius: 3px\"> Formation is a no dependency, Bootstrap themeable form builder for Vue.js. The following are its goals/features <ul> <li>Build form layouts of any complexity using JSON</li> <li>Bind all form data to a single reactive object</li> <li>Provide optional controls over all styling</li> <li>Integrate native options for validation</li> <li>Provide a small set of UI components that can be accessed natively or standalone</li> </ul> </div> <h3>Usage</h3> <div> <h4 class=text-primary><span class=\"fa fa-code\"></span> CommonJS</h4> <pre>// npm install vue-formation\n<code class=language-JavaScript>\nvar Formation = require('vue-formation').Formation;\n\nnew Vue({\n  components: {\n    Formation: Formation\n  }\n})</code></pre> </div> <p>&nbsp;</p> <div> <h4 class=text-primary><span class=\"fa fa-code\"></span> ES6</h4> <pre>// npm install vue-formation\n<code class=language-JavaScript>\nimport { Formation } from 'vue-formation'\n\nnew Vue({\n  components: {\n    Formation\n  }\n})</code></pre> </div> <p>&nbsp;</p> <div v-if=\"1 === 2\"> <h4 class=text-primary><span class=\"fa fa-code\"></span> AMD</h4> <pre>// bower install vue-formation\n<code class=language-JavaScript>\nvar Formation = require('vue-formation').Formation;\n\nnew Vue({\n  components: {\n    Formation: Formation\n  }\n})</code></pre> </div>";

/***/ },
/* 219 */
/***/ function(module, exports) {

	module.exports = " <div> <h5 @click=\"collapse(typeId, section)\" style=\"cursor: pointer\"> <span :class=\"{ 'fa fa-caret-down': !isCollapsed(typeId, section), 'fa fa-caret-right': isCollapsed(typeId, section) }\"></span> {{ header || section }} </h5> <div :class=\"{ collapse: isCollapsed(typeId, section) }\"> <slot></slot> </div> </div> ";

/***/ },
/* 220 */
/***/ function(module, exports) {

	module.exports = " <div> <div v-for=\"(docId, doc) in Docs\"> <h3>{{ doc.title }}</h3> <h5><a><span @click=vm.showCode(doc.exampleId) class=\"fa fa-code\"></span></a> Example</h5> <div v-if=\"docId === 'formation'\" class=well> <formation :data.sync=vm.exampleData[doc.exampleId] :config=vm[doc.exampleId]></formation> </div> <div v-if=\"docId === 'ftabs'\" class=well> <f-tabs :config=vm[doc.exampleId]> <div slot=tab1 class=bg-primary style=\"padding: 10px; margin-top: 5px\"> <h3>Tab 1</h3> </div> <div slot=tab2 class=bg-warning style=\"padding: 10px; margin-top: 5px\"> <h3>Tab 2</h3> </div> <div slot=tab3 class=bg-danger style=\"padding: 10px; margin-top: 5px\"> <h3>Tab 3</h3> </div> </f-tabs> </div> <div v-if=\"docId === 'fmodal'\" class=well> <button type=button @click=\"show = true\" class=\"btn btn-primary\"> Open Modal </button> <f-modal :show.sync=show :config=vm[doc.exampleId]> <div slot=body> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </div> </f-modal> </div> <div v-if=doc.params> <h5 class=doc-header>Parameters</h5> <table class=\"table table-bordered\"> <thead> <tr class=active> <th>Name</th> <th>Type</th> <th>TwoWay</th> <th>Required</th> <th>Default</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"param in doc.params | orderBy 'name'\"> <td class=text-nowrap>{{ param.name }}</td> <td class=text-nowrap>{{{ typeLinks(param.type) }}}</td> <td><span v-if=param.twoWay class=\"fa fa-check\"></span></td> <td><span v-if=param.required class=\"fa fa-check\"></span></td> <td>{{{ param.default }}}</td> <td>{{{ param.description }}}</td> </tr> </tbody> </table> </div> <div v-if=doc.events> <h5 class=doc-header>Events</h5> <table v-for=\"event in doc.events | orderBy 'type'\" class=\"table table-bordered\" style=\"margin-bottom: 10px\"> <thead class=active> <tr class=active> <th>{{ event.type }}</th> </tr> </thead> <tbody> <tr> <td> {{ event.description }} <table v-if=event.params class=\"table table-condensed\" style=\"margin-bottom: 0px\"> <thead> <tr> <th>Parameter</th> <th>Type</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"param in event.params | orderBy 'name'\"> <td>{{ param.name }}</td> <td>{{{ typeLinks(param.type) }}}</td> <td>{{{ param.description }}}</td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </div> <div v-if=doc.listeners> <h5 class=doc-header>Listeners</h5> <table v-for=\"event in doc.listeners | orderBy 'type'\" class=\"table table-bordered\" style=\"margin-bottom: 10px\"> <thead> <tr class=active> <th>{{ event.type }}</th> </tr> </thead> <tbody> <tr> <td> {{ event.description }} <table v-if=event.params class=\"table table-condensed\" style=\"margin-bottom: 0px\"> <thead> <tr> <th>Parameter</th> <th>Type</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"param in event.params | orderBy 'name'\"> <td>{{ param.name }}</td> <td>{{{ typeLinks(param.type) }}}</td> <td>{{{ param.description }}}</td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </div> </div> </div> ";

/***/ },
/* 221 */
/***/ function(module, exports) {

	module.exports = " <div @click=clickAway> <div v-if=show :transition=\"animation !== 'none' ? animation : null\" v-el:modal class=modal style=\"display: block\" :style=\"{ 'z-index': zIndex + 1 }\" :class=\"{ 'mopen': open, 'mclose': !open }\" role=dialog> <div class=modal-dialog role=document style=\"z-index: 2000\"> <div v-el:content class=modal-content> <div v-if=\"config.showHeader !== false\" class=modal-header :class=config.headerClass :style=config.headerStyle> <slot name=header> <button v-if=\"config.headerClose !== false\" type=button class=close @click=hideModal()> <span aria-hidden=true>&times;</span> </button> <h4 class=modal-title> <span v-if=config.headerIconClass :class=config.headerIconClass></span> {{ title || config.title }} </h4> </slot> </div> <div v-if=\"config.showBody !== false\" class=modal-body :class=config.bodyClass :style=config.bodyStyle> <slot name=body> {{{ isFunction(config.body) ? config.body(this) : config.body }}} </slot> </div> <div v-if=\"config.showFooter !== false\" class=modal-footer :class=config.footerClass :style=config.footerStyle> <slot name=footer> {{{ isFunction(config.footer) ? config.footer(this) : config.footer }}} <button v-for=\"button in config.footerButtons\" @click=\"button.onClick ? button.onClick($event, this) : null\" :class=button.class :style=button.style> {{{ button.content }}} </button> </slot> </div> </div> </div> </div> <div :transition=\"animation !== 'none' ? animation : null\" v-if=\"backdrop && show\" class=backdrop-container :class=\"{ 'mopen': open, 'mclose': !open }\"> <div class=modal-backdrop :style=\"{ 'z-index': zIndex, 'opacity': backdropOpacity }\"> </div> </div> </div> ";

/***/ },
/* 222 */
/***/ function(module, exports) {

	module.exports = " <div class=\"dropdown fselect\" :class=\"{ 'open': open }\" :class=\"{ 'has-error': !valid }\"> <div type=text v-el:selectcontainer class=\"dropdown-toggle form-control\" @click=toggleDropdown :style=\"{ 'width': width, 'text-align': align !== 'center' ? 'left' : null, 'height': 'auto', 'display': 'flex' }\" style=\"position: relative; font-weight: normal; height: auto; display: flex\"> <div class=select-body v-el:selectbody> <span v-if=\"value.length === 0\" v-el:placeholder class=placeholder-text>{{ placeholder }}</span> <span v-if=\"value.length > 0 && !multiple\" class=placeholder-text>{{ singleValueText }}</span> <span v-if=\"value.length > 0 && multiple\" v-for=\"item in multiValue\" track-by=$index class=select-tag :class=tagClass> <span v-if=!disabled :class=removeClass @click=\"emitChange('remove', item[valueKey], selectId)\"></span> <span>{{ item[textKey] }}</span> </span> </div> <span class=caret-position :class=interactClass @click=\"emitChange('clear', undefined, selectId)\"></span> <select class=form-control style=\"width: 1px; float: right; visibility: hidden\"></select> </div> <ul class=\"dropdown-menu scrollable-dropdown\" :style=\"{ 'width': width }\"> <li class=search-field> <input v-show=searchable v-el:search @keydown=searchHandler type=text v-model=search class=form-control style=\"width: 100%; margin-bottom: 5px\" placeholder=Search...> <span v-if=\"searchable && !searchResults.length\"> <i>No Results Found...</i> </span> </li> <li v-for=\"opt in options | selectable\" :class=\"{ active: isSelected(opt) }\" @mouseover=\"activeOption = $index\"> <a @click=\"emitChange('add', opt[valueKey], selectId)\" :class=\"{ hovered: activeOption === $index }\">{{ opt[textKey] }}</a> </li> </ul> </div> ";

/***/ },
/* 223 */
/***/ function(module, exports) {

	module.exports = " <div> <ul class=\"nav nav-tabs\"> <li v-for=\"tab in config.tabs\" v-if=\"tab.show !== false\" :class=\"{ 'active': tab.id === active }\"> <a @click=activate(tab.id)> {{ tab.text || tab.id }} </a> </li> </ul> <div class=tab-content> <div class=tab-pane v-for=\"tab in config.tabs\" v-if=\"tab.show !== false\" :class=\"{ 'active': tab.id === active }\"> <slot :name=tab.id></slot> </div> </div> </div> ";

/***/ },
/* 224 */
/***/ function(module, exports) {

	module.exports = " <div class=formation> <div v-if=isBootstrapFormat class=\"container-fullwidth formation-container\"> <form role=form :class=\"{ 'form-inline': config.format === 'inline', 'form-horizontal': config.format === 'horizontal' }\"> <div v-for=\"(rIdx, row) in formConfig\" :transition=\"config.transition || null\" :transition-enter=\"config.transitionEnter || null\" :transition-leave=\"config.transitionLeave || null\" :stagger=\"config.stagger || null\" :enter-stagger=\"config.enterStagger || null\" :leave-stagger=\"config.leaveStagger || null\" :class=\"{ 'pull-left': config.align === 'left', 'pull-right': config.align === 'right' }\"> <div class=\"row form-group\" :class=\"{ 'form-group-autoheight': row.type !== 'section', 'no-vertical-spacing': row.type === 'section' }\" :style=\"{ 'height': row.height }\"> <div v-if=row.columns v-for=\"(fIdx, form) in row.columns\" class=form-group :id=\"formGroupId(rIdx, fIdx)\" :class=\"colClass(row.columns, rIdx, fIdx, form.model)\" :style=\"{ 'margin-right': $index === row.columns.length - 1 ? '-1px' : null }\"> <label :for=\"formId(rIdx, fIdx)\" :style=\"{ 'float': config.alignLabels, 'width': '100%' }\"> {{{ getLabel(rIdx, fIdx, form.label) }}} <span v-if=\"config.decorateRequired !== false && form.required && form.label\" class=text-danger> * </span> <input v-if=isTextInput(form.type) :type=form.type :name=\"formId(rIdx, fIdx)\" :id=\"formId(rIdx, fIdx)\" style=\"width: 100%\" class=form-control :class=form.class :style=form.style :placeholder=form.placeholder :disabled=\"has(form, 'bind.disabled') ? form.bind.disabled() : formDisabled()\" v-model=formData[form.model]> <div v-if=\"form.type === 'html'\" style=\"width: 100%\">{{{ form.value }}}</div> <button v-if=\"form.type === 'button'\" class=btn :class=form.class :style=form.style :disabled=\"has(form, 'bind.disabled') ? form.bind.disabled() : formDisabled()\" @click.prevent=\"form.onClick ? form.onClick($event, this) : null\"> <span v-if=form.iconClass , :class=form.iconClass></span> <span v-if=\"form.iconClass && form.text\">&nbsp;</span> <span v-if=form.text>{{ form.text }}</span> </button> <div v-if=\"form.type === 'buttons'\" :class=\"{ 'btn-group': form.group }\" :role=\"form.group ? 'group' : null\"> <button v-for=\"btn in form.buttons\" class=btn :class=btn.class :style=btn.style :disabled=\"has(btn, 'bind.disabled') ? btn.bind.disabled() : formDisabled()\" @click.prevent=\"btn.onClick ? btn.onClick($event, this) : null\"> <span v-if=btn.iconClass , :class=btn.iconClass></span> <span v-if=\"btn.iconClass && btn.label\">&nbsp;</span> <span v-if=btn.text>{{ btn.text }}</span> </button> </div> <div v-if=\"form.type === 'checkbox'\"> <label> <input type=checkbox :class=form.class :style=form.style :id=\"formId(rIdx, fIdx)\" :disabled=\"has(form, 'bind.disabled') ? form.bind.disabled() : formDisabled()\" v-model=formData[form.model]> {{ form.text }} </label> </div> <div v-if=\"form.type === 'radio'\" class=radio> <label v-for=\"(oIdx, radio) in form.filter ? form.filter(formData[form.model], form.radios) : form.radios\" style=\"display: block\"> <input type=radio :name=\"formId(rIdx, fIdx)\" :id=\"formId(rIdx, fIdx)\" :disabled=\"has(form, 'bind.disabled') ? form.bind.disabled() : formDisabled()\" :value=radio.value v-model=formData[form.model]> {{ radio.label }} </label> </div> <div v-if=\"form.type === 'select'\"> <select class=form-control :id=\"formId(rIdx, fIdx)\" :disabled=\"has(form, 'bind.disabled') ? form.bind.disabled() : formDisabled()\" @blur=\"form.onBlur ? form.onBlur(event, utils) : null\" @change=\"form.onChange ? form.onChange(event, utils) : null\" v-model=formData[form.model]> <option v-for=\"opt in form.filter ? form.filter(formData[form.model], form.options) : form.options\" :value=opt.value :hidden=opt.hidden> {{ opt.text }} </option> </select> </div> <slot v-if=\"form.type === 'slot' && form.name\" :name=form.name></slot> <f-select v-if=\"form.type === 'fselect'\" :close-on-select=form.closeOnSelect :width=form.width :value.sync=formData[form.model] :options=form.options :placeholder=form.placeholder :store-object=form.storeObject :multiple=form.multiple :text-key=form.textKey :value-key=form.valueKey :on-add=form.onAdd :on-adding=form.onAdding :on-change=form.onChange :on-changing=form.onChanging :on-clear=form.onClear :on-clearing=form.onClearing :on-close=form.onClose :on-closing=form.onClosing :on-remove=form.onRemove :on-removing=form.onRemoving> </f-select> </label> </div> </div> </div> </form> </div> </div> ";

/***/ },
/* 225 */
/***/ function(module, exports) {

	module.exports = " <link v-el:link v-if=cookie.theme rel=stylesheet :href=cookie.theme id=page-theme> ";

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div id=app> <nav id=topnav class=\"navbar navbar-default\" style=\"margin-bottom: 0px\"> <div class=container> <div class=navbar-header> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar aria-expanded=false aria-controls=navbar> <span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> </button> <a class=navbar-brand href=# style=\"height: 100%\"> <img v-if=cookie.logoInverted src=" + __webpack_require__(168) + " style=\"display: inline-block; height: 35px; width: 50px\"> <img v-if=!cookie.logoInverted src=" + __webpack_require__(169) + " style=\"display: inline-block; height: 35px; width: 50px\"> </a> </div> <div id=navbar class=\"navbar-collapse collapse pull-right\" style=\"height: 100%; top: 1em; position: relative\"> <form class=form-inline> <div class=form-group> <label for=themer class=navbar-text style=\"line-height: 0.5em\">Change Theme&nbsp;&nbsp;</label> <theme-selector style=width:200px id=themer class=form-control></theme-selector> </div> </form> </div> </div> </nav> <div class=\"jumbotron jumbotron-fluid\" style=\"background-color: #3368bb; color: #fff; margin-bottom: 10px\"> <div class=container> <h1 class=display-3 style=\"color: #fff; font-weight: 500; margin-top: 0px\">VueFormation</h1> <p class=lead style=\"color: #fff\">A <b>Bootstrap</b> themeable <b>Vue.js</b> form builder <br> Build complex <b>reactive</b> form layouts using <b>JSON</b></p> <p class=lead> <a style=\"border: 1px solid #fff; color: #fff\" class=\"btn btn-lg\" href=https://github.com/bhoriuchi/vue-formation role=button> <span class=\"fa fa-github\"></span> Code on GitHub </a> </p> </div> </div> <div class=container> <f-tabs :active.sync=mainTabActive :config=mainTabConfig> <div slot=about> <about></about> </div> <div slot=examples> <div v-for=\"(exampleId, example) in Examples\" v-if=\"example.showExample !== false\"> <h3><a><span @click=showCode(exampleId) class=\"fa fa-code\"></span></a> {{ example.title }}</h3> <p>{{ example.description }}</p> <div v-if=\"example.exampleType === 'formation'\" class=\"row well\"> <div class=col-md-8> <formation :data.sync=exampleData[exampleId] :config=self[exampleId]></formation> </div> <div class=col-md-4> <label style=\"width: 100%\"> <b>Form Data</b> <pre style=\"font-size: 10px;background-color: #fff\">\n{{ exampleData[exampleId] | json }}\n</pre> </label> </div> </div> </div> </div> <div slot=components> <components-doc :vm=self></components-doc> </div> <div slot=types> <types-doc></types-doc> </div> </f-tabs> </div> <f-modal v-ref:codemodal> <f-tabs slot=body :config=sourceTabConfig :active.sync=sourceTabActive style=\"width: 100%\"> <div slot=config> <pre style=\"max-height: 30em\"><code class=\"prism language-javascript\">{{ source.config }}</code></pre> </div> <div slot=data v-if=source.data> <pre style=\"max-height: 30em\"><code class=\"prism language-javascript\">{{ source.data }}</code></pre> </div> <div slot=html> <pre style=\"max-height: 30em\"><code class=\"prism language-markup\">{{ source.html }}</code></pre> </div> </f-tabs> </f-modal> <f-modal modal-id=dialog></f-modal> <f-modal modal-id=theme-selector> <div slot=body> <form style=width:100%> <div class=form-group :class=\"{ 'has-error': customUrlError }\"> <label for=theme-css-url>Custom Theme URL</label> <input v-model=customUrl type=url class=form-control id=theme-css-url placeholder=\"Enter theme URL...\"> </div> </form> </div> </f-modal> </div> ";

/***/ },
/* 227 */
/***/ function(module, exports) {

	module.exports = " <select v-model=value @change=onChange> <option v-for=\"opt in cookie.themes | orderBy 'text'\" :value=opt.value :selected=\"opt.value === cookie.theme \">{{ opt.text }}</option> </select> ";

/***/ },
/* 228 */
/***/ function(module, exports) {

	module.exports = " <div v-for=\"(typeId, type) in Types\"> <h3><a name=\"{{ typeId }}\"><span class=\"fa fa-hashtag\"></span></a> {{ type.title }}</h3> <collapsable-section :type-id=typeId :tab=tab header=Description section=description> {{ type.description }} </collapsable-section> <div v-if=type.example> <collapsable-section :type-id=typeId :tab=tab header=Example section=example> <pre><code class=\"prism language-javascript\">{{ stringify(type.example) }}</code></pre> </collapsable-section> </div> <div v-if=type.structure> <collapsable-section :type-id=typeId :tab=tab header=Structure section=structure> <table class=\"table table-bordered\"> <thead v-if=\"type.structure.length > 0\"> <tr class=active> <th>Path</th> <th>Type</th> <th>Required</th> <th>Default</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"prop in type.structure | orderBy 'path'\"> <td>{{ prop.path }}</td> <td class=text-nowrap>{{{ typeLinks(prop.type) }}}</td> <td><span v-if=prop.required class=\"fa fa-check\"></span></td> <td>{{{ prop.default }}}</td> <td>{{{ prop.description }}}</td> </tr> <tr v-if=type.extends v-for=\"(eIdx, eRow) in getInherited(type.extends)\" :class=\"{ active: (eIdx % 2) === 0 }\"> <td colspan=5> {{{ eRow }}} </td> </tr> </tbody> </table> </collapsable-section> </div> <div v-if=type.enums> <collapsable-section :type-id=typeId :tab=tab header=Enums section=enums> <table class=\"table table-bordered\"> <thead> <tr class=active> <th>Value</th> <th>Description</th> </tr> </thead> <tbody> <tr v-for=\"enum in type.enums | orderBy 'value'\" :class=\"{ undocumented: enum.undocumented }\"> <td>{{ enum.value }}</td> <td>{{{ enum.description }}}</td> </tr> </tbody> </table> </collapsable-section> </div> </div> ";

/***/ },
/* 229 */
/***/ function(module, exports) {

	module.exports = " <div class=hello _v-a8dd827e=\"\"> <h1 _v-a8dd827e=\"\">{{ msg }}</h1> </div> ";

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(157)
	__vue_script__ = __webpack_require__(96)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_template__ = __webpack_require__(218)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(97)
	__vue_template__ = __webpack_require__(219)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(158)
	__vue_script__ = __webpack_require__(98)
	__vue_template__ = __webpack_require__(220)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(159)
	__vue_script__ = __webpack_require__(99)
	__vue_template__ = __webpack_require__(221)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(101)
	__vue_template__ = __webpack_require__(223)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(161)
	__vue_script__ = __webpack_require__(102)
	__vue_template__ = __webpack_require__(224)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(103)
	__vue_template__ = __webpack_require__(225)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(162)
	__vue_script__ = __webpack_require__(105)
	__vue_template__ = __webpack_require__(226)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(163)
	__vue_script__ = __webpack_require__(107)
	__vue_template__ = __webpack_require__(228)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.276df2df1c90849f33e1.js
 **/